import { AI_MODELS, PRO_MODELS_TEXT } from '../../constants/aiModels';
import { getMaxDiscountLabel } from '../../config/seasonConfig';

// cutover 시점별 시즌 특가 카피
const _helpMaxDiscount = getMaxDiscountLabel();

// 업데이트 내역 (최신순)
// summary    : 목록 카드에 보일 한 줄 요약
// categories : UPDATE_CATEGORIES의 id (목록 필터)
// content    : 상세 본문 HTML. sections([{ title, description, image, items }])가 있으면 sections를 먼저 쓴다.
//              image: { src, alt, caption } — 실제 화면 캡처. public/images/help/<업데이트 id>/ 에 둔다.
// links      : 상세 아래 바로가기 [{ label, path }]
// popup      : { slides: [{ image, alt }], tabLabel } 가 있으면 새 소식 팝업에 카드뉴스로 보인다 (config/whatsNew.js)
//              카드는 public/images/whats-new/<업데이트 id>/ 에 두고, 자세한 내용은 이 글로 연결된다.
export const UPDATES = [
  {
    id: 'update-2026-11-reference-depth',
    date: '2026-11-04',
    title: '자료 여러 개, 지난 대화 여러 개를 한 번에 모아 써요',
    summary: '"관련 자료 전부"라고만 하면 AI가 여러 자료와 대화를 찾아 읽고 한 번에 정리해요.',
    categories: ['chat'],
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '"내 자료함의 학부모 상담 자료 전부 참고해서"라고 하면, 관련 자료를 하나만 고르지 않고 여러 개를 찾아 모두 읽은 뒤 답해요.',
          '"지난 몇 달 동안 만든 상담 문자들"처럼 말하면 지난 대화도 여러 개를 모아 읽어요.',
          '아주 긴 계획서에서도 필요한 부분을 찾아 읽고 답해요.',
          '자료함과 지난 대화를 섞어서, 찾고 읽고 쓰는 일을 한 번에 시킬 수 있어요.',
          'AI가 지금 무엇을 읽고 있는지 답 위에 차례대로 보여 드려요.',
        ],
      },
      {
        title: '1. 관련 자료를 여러 개 한 번에 읽어요',
        description: '파일 이름을 하나하나 말하지 않아도 돼요. "학부모 상담 관련 자료들 전부 참고해서 2학기 상담 운영 계획을 한 장으로 만들어 줘"라고 하면, 자료함에서 상담 신청서, 상담 일지, 1학기 운영 계획, 상담 결과 요약을 찾아 차례로 읽고 하나의 계획으로 묶어요.',
        image: {
          src: '/images/help/update-2026-11-reference-depth/many-materials.jpg',
          alt: '학부모 상담 관련 자료 전부 참고해서 2학기 상담 운영 계획을 만들어 달라는 요청 아래에 상담 신청서·회신서 양식, 학생 상담 일지 양식, 학부모 상담주간 운영 계획(1학기) 읽음 표시와 1학기 학부모 상담 결과 요약 읽는 중이 보이는 화면',
          caption: '읽은 자료는 체크로, 지금 읽는 자료는 돌아가는 표시로 보여요',
        },
      },
      {
        title: '2. 지난 대화 여러 개를 모아 정리해요',
        description: '"지난 몇 달 동안 만든 학부모 상담 문자들 말투를 다 모아서, 앞으로 쓸 공통 문자 틀로 정리해 줘"라고 하면 9월, 10월, 11월에 나눈 대화를 모두 찾아 읽고 공통점을 뽑아 틀로 만들어요. 매번 새로 쓰던 글을 내 스타일 그대로 모아 정리할 때 좋아요.',
        image: {
          src: '/images/help/update-2026-11-reference-depth/many-chats.jpg',
          alt: '지난 몇 달 동안 만든 학부모 상담 문자 말투를 모아 공통 문자 틀로 정리해 달라는 요청 아래에 11월, 10월 학부모 상담 문자 대화 읽음과 9월 상담 문자 대화 읽는 중이 보이는 화면',
          caption: '지난 대화는 학생 이름을 가린 채로 읽어요',
        },
      },
      {
        title: '3. 긴 문서 속 한 줄도 찾아 답해요',
        description: '수십 쪽짜리 교육과정 운영 계획서처럼 긴 문서도 처음 몇 쪽만 보고 끝내지 않아요. "운영 계획서에서 방과후학교 예산 총액이 얼마였는지 찾아 줘"라고 하면 그 부분을 찾아 읽고 숫자로 답해요.',
        image: {
          src: '/images/help/update-2026-11-reference-depth/long-document.jpg',
          alt: '방과후학교 운영 예산 총액은 4,860만 원이며 학교 예산 2,310만 원, 교육청 지원 2,550만 원이라는 답과 내 자료함에서 2026 학교 교육과정 운영 계획서(전체) 참고 안내가 보이는 화면',
          caption: '어느 문서에서 찾았는지 답 아래에 함께 보여요',
        },
      },
      {
        title: '4. 찾고, 읽고, 쓰는 일을 한 번에 시켜요',
        description: '여러 단계로 나눠 시키지 않아도 돼요. "자료함의 1학기 상담 결과 요약이랑 지난번 학부모 상담 문자들을 같이 보고, 교우 관계 상담이 필요한 학생 보호자께 보낼 11월 안내 문자를 써 줘"라고 한 번에 말하면, AI가 자료함과 지난 대화를 각각 찾아 읽은 뒤 문자를 써요.',
        image: {
          src: '/images/help/update-2026-11-reference-depth/mix-steps.jpg',
          alt: '자료함 1학기 상담 결과 요약과 지난 학부모 상담 문자를 함께 보고 11월 상담 안내 문자를 써 달라는 요청 아래에 자료함 자료 1개와 지난 대화 3개를 차례로 읽는 화면',
          caption: '앞에서 정리해 둔 공통 문자 틀 대화도 스스로 찾아 함께 읽어요',
        },
      },
      {
        title: '5. 무엇을 보고 썼는지 확인하세요',
        description: '답 아래에 참고한 자료와 대화가 한 줄로 보여요. 지난 대화 안내를 누르면 읽은 대화가 펼쳐지고, 제목을 누르면 그 대화로 가요. 참고하지 않았으면 하는 대화는 참고 안 함을 누르세요. 자료함 안내에 마우스를 올리면 읽은 자료 이름이 모두 보여요. 빠진 자료가 있으면 이름을 말해 다시 시키세요.',
        image: {
          src: '/images/help/update-2026-11-reference-depth/mix-result.jpg',
          alt: '11월 교우 관계 상담 안내 문자 카드와 그 아래 내 자료함에서 1학기 학부모 상담 결과 참고, 지난 대화 학부모 상담 문자 공통 외 2개 참고 안내, 조금 더 따뜻하게 바꿔줘 같은 이어서 시키기 버튼이 보이는 화면',
          caption: '아래 버튼으로 말투를 바꾸거나 더 짧게 줄이는 것도 이어서 시킬 수 있어요',
        },
      },
      {
        title: '6. 이렇게 시키면 더 잘해요',
        items: [
          '범위를 말해 주세요. "상담 관련 자료 전부", "지난 두 달 동안 만든 가정통신문"처럼 어떤 묶음을 볼지 말하면 그 안에서 빠짐없이 찾아요.',
          '무엇을 만들지 함께 말해 주세요. "모아서 한 장으로", "비교해서 표로", "공통 틀 하나로"처럼 결과 모양을 정해 주면 여러 자료를 읽은 뒤 그 모양으로 묶어요.',
          '어디를 볼지 알면 알려 주세요. "운영 계획서에서 예산 부분"처럼 말하면 긴 문서에서도 더 정확하게 찾아요.',
          '자료함과 지난 대화를 한 문장에 같이 적어도 돼요. "자료함의 ○○이랑 지난번 ○○ 대화를 같이 보고"처럼요.',
          '결과를 받은 뒤에는 이어서 시키세요. "이걸 한글 파일로 만들어 줘", "학년별로 나눠 줘", "보호자용으로 더 짧게"처럼 바로 다음 일을 맡기면 앞에서 읽은 내용을 이어 써요.',
          '한 번 정리한 결과도 다음에 다시 찾아 써요. 공통 문자 틀처럼 자주 쓸 틀을 한 번 만들어 두면, 다음 요청 때 그 대화도 함께 참고해요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          '여러 자료를 읽을 때는 답이 몇 초 더 걸릴 수 있어요. 지금 무엇을 읽는지는 답 위에서 볼 수 있어요.',
          '한 번에 함께 살펴보는 건 자료함과 지난 대화 각각 8개 정도까지예요. 더 많으면 "1학기 것만", "6학년 것만"처럼 범위를 좁혀 주세요.',
          '답 아래 안내에는 참고한 자료와 대화가 각각 5개까지 보여요.',
          '아주 긴 문서는 필요한 부분 위주로 읽어요. 찾을 내용을 구체적으로 말할수록 정확해져요.',
          '자료함에 모인 자료와 지난 대화만 찾아요. 무료는 직접 적은 텍스트 자료 3개와 채팅에서 모은 파일 최근 20개까지, PRO는 500개까지 남겨요.',
          '학생 정보로 보이는 파일과 생기부 만들기·상담 대화에 올린 파일은 자동으로 모으지 않아요.',
          'AI 맞춤 설정 → AI가 찾아 쓰는 자료에서 끄면 자료함과 지난 대화를 찾지 않아요.',
        ],
      },
    ],
    links: [
      { label: 'AI 채팅 열기', path: '/chat' },
      { label: 'AI 맞춤 설정', path: '/chat/settings' },
      { label: '처음 소개: 지난번에 올린 파일, 다시 안 올려도 돼요', path: '/help/notice/update-2026-11-ai-reference' },
    ],
  },
  {
    id: 'update-2026-11-saenggibu-evidence',
    date: '2026-11-02',
    title: '생기부 문장, 어디서 나왔는지 바로 보여요',
    summary: '만든 생기부 문장마다 내가 넣은 내용의 번호를 달고, 고르고 싶은 문장만 골라 고칠 수 있어요.',
    categories: ['saenggibu'],
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '생기부 문장 끝에 작은 번호가 붙어요. 번호는 내가 넣은 내용(입력한 글, 키워드, 첨부 파일)의 몇 번째 내용으로 쓴 문장인지 알려줘요.',
          '결과 아래에 "넣은 내용 6개 중 6개를 썼어요"처럼 한 줄로 보여 드려요. 빠진 내용이 있는지 바로 알 수 있어요.',
          '마음에 들지 않는 문장 하나만 골라 다른 표현으로 바꾸거나, 짧게 줄이거나, 뺄 수 있어요.',
          '한 명씩 만들기, 여러 명 한 번에 만들기, 내 생기부 기록에서 모두 볼 수 있어요.',
        ],
      },
      {
        title: '1. 문장마다 번호가 붙어요',
        description: '생기부를 만들면 문장 끝에 번호가 붙고, 결과 아래에 내가 넣은 내용을 몇 개 썼는지 한 줄로 보여요. 번호가 거슬리면 번호 숨기기를 누르세요. 복사할 때는 번호가 빠져요.',
        image: {
          src: '/images/help/update-2026-11-saenggibu-evidence/result-card.jpg',
          alt: '생기부 문장 끝에 4,5 / 6 / 3 / 2 / 1 같은 번호가 붙어 있고, 아래에 넣은 내용 6개 중 6개를 썼어요, 근거 보기, 번호 숨기기가 보이는 결과 카드',
          caption: '"정리"는 넣은 내용을 모아 마무리한 문장이에요',
        },
      },
      {
        title: '2. 근거 보기에서 문장을 누르면 쓴 내용이 보여요',
        description: '근거 보기를 누르면 왼쪽에 내가 넣은 내용, 오른쪽에 생기부가 나와요. 문장을 누르면 그 문장에 쓴 내용이 왼쪽에서 함께 표시돼요. 반대로 왼쪽 내용을 누르면 그 내용으로 쓴 문장을 찾아 줘요.',
        image: {
          src: '/images/help/update-2026-11-saenggibu-evidence/dialog.jpg',
          alt: '근거 보기 창. 왼쪽에 책임감 있음, 친구를 잘 도움 등 입력한 내용 6개, 오른쪽 생기부에서 모둠 활동 문장을 누르자 6번 모둠 활동에서 의견을 조율함이 함께 표시된 화면',
          caption: '휴대폰에서는 생기부와 내가 넣은 내용을 탭으로 오가며 봐요',
        },
      },
      {
        title: '3. 고르고 싶은 문장만 고쳐요',
        description: '문장을 고른 뒤 다른 표현으로, 짧게, 요청해서 고치기, 직접 고치기, 이 문장 빼기 중 하나를 누르세요. AI가 그 문장만 새로 쓰고, 바꾸기 전과 후를 먼저 보여 드려요. 이대로 바꾸기를 눌러야 반영돼요.',
        image: {
          src: '/images/help/update-2026-11-saenggibu-evidence/revise.jpg',
          alt: '모둠 활동 문장을 다른 표현으로 바꾼 미리보기. 바꾸기 전 문장에 취소선, 아래에 새 문장과 797B에서 826B로 바뀐 글자 수, 그대로 두기와 이대로 바꾸기 버튼',
          caption: '바꾼 문장은 내 생기부 기록에도 저장돼요',
        },
      },
      {
        title: '4. 여러 명을 만들 때도, 첨부 파일도 봐요',
        description: '여러 명 한 번에 만들기에서는 학생마다 따로 보고, 위의 화살표로 다음 학생으로 넘어가요. 첨부 파일은 파일마다 몇 곳에 썼는지 알려 드려요. 아직 쓰지 않은 내용은 눌러서 이 내용 넣기로 바로 생기부에 더할 수 있어요.',
        image: {
          src: '/images/help/update-2026-11-saenggibu-evidence/history-file.jpg',
          alt: '내 생기부 기록의 근거 보기. 학생 활동 내용, 첨부한 PDF와 한글 파일, 성취기준이 나뉘어 있고 파일마다 2곳을 썼어요, 3곳을 썼어요가 표시된 화면',
          caption: '영어로 된 파일도 한글 문장과 이어서 찾아 줘요',
        },
      },
      {
        title: '알아 두세요',
        items: [
          '번호는 AI가 문장과 넣은 내용을 맞춰 본 결과예요. 번호가 없는 문장은 넣은 내용과 이어진 곳을 찾지 못한 문장이니, 한 번 더 읽어 봐 주세요.',
          '근거 보기를 위해 생성할 때 넣은 내용과 첨부 파일에서 읽은 글을 연락처 등 개인정보를 가린 채로 생기부 기록과 함께 보관해요. 원본 파일은 보관하지 않고, 기록을 지우면 함께 지워요.',
          '여러 반 한 번에 만들기에서는 첨부 파일 내용에 번호가 붙지 않아요. 입력한 글에서 나온 문장만 번호가 붙어요.',
        ],
      },
    ],
    links: [
      { label: '생기부 만들기', path: '/create-saenggibu' },
      { label: '내 생기부 기록', path: '/saenggibu-history' },
      { label: '개인정보처리방침 변경 안내', path: '/help/notice/privacy-policy-update-2026-11-ai-reference' },
    ],
    popup: {
      tabLabel: '생기부 근거 보기',
      slides: [
        { image: '/images/whats-new/update-2026-11-saenggibu-evidence/slide-1.jpg', alt: '이 문장, 어디서 나왔을까요? / 생기부 문장마다 근거 번호를 달아 드려요, 누르면 입력한 내용이 바로 보여요' },
        { image: '/images/whats-new/update-2026-11-saenggibu-evidence/slide-2.jpg', alt: '고르고 싶은 문장만 고쳐요 / 다른 표현으로, 짧게, 이 문장 빼기 / 안 쓴 내용은 한 번에 넣어요' },
      ],
    },
  },
  {
    id: 'update-2026-11-ai-reference',
    date: '2026-11-02',
    title: '지난번에 올린 파일, 다시 안 올려도 돼요',
    summary: '채팅에 올린 파일과 지난 대화를 AI가 필요할 때 찾아 써요. AI 맞춤 설정에서 언제든 끌 수 있어요.',
    categories: ['chat'],
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '"지난번에 올린 수업 계획서로 안내문 써 줘"라고만 하면, 파일을 다시 올리지 않아도 내 자료함에서 찾아 써요.',
          '"지난번에 쓴 가정통신문을 겨울방학용으로 바꿔 줘"처럼 지난 대화를 이어 쓸 수도 있어요.',
          '어떤 자료와 대화를 참고했는지 답 아래에 한 줄로 보여 드려요.',
          '학생 명단·성적표·상담 기록·생활기록부처럼 학생 정보로 보이는 파일은 모으지 않아요. 지난 대화도 학생 이름은 가린 채로 참고해요.',
        ],
      },
      {
        title: '1. 처음부터 켜져 있어요',
        description: '11월 4일부터 따로 허용하지 않아도 채팅에 올린 문서를 내 자료함에 모아 두고, 지난 대화도 필요할 때 찾아 써요. 끄고 싶으면 AI 맞춤 설정에서 끌 수 있고, 이미 허용 안 함을 고른 분은 계속 꺼져 있어요.',
      },
      {
        title: '2. 파일 이름만 말하면 찾아 써요',
        description: '첨부 없이 "지난번에 올린 2학기 사회 수업 운영 계획서로 학부모 안내문 써 줘"라고 하면, 자료함에서 그 파일을 찾아 읽고 답해요. 참고한 자료는 답 아래에 보여요.',
        image: {
          src: '/images/help/update-2026-11-ai-reference/labels.jpg',
          alt: '만든 한글 파일 아래에 학부모 소통 형식으로 정리했어요 · 바꾸기, 내 자료함에서 2학기 사회 수업 운영… 참고 안내가 한 줄로 보이는 화면',
          caption: '자료함에 없는 파일이면 지어내지 않고, 다시 올릴지 먼저 물어봐요',
        },
      },
      {
        title: '3. 지난 대화도 이어 써요',
        description: '"지난번에 쓴 현장체험학습 가정통신문을 겨울방학 안내로 바꿔 줘"라고 하면 그 대화를 찾아 이어 써요. 답 아래 안내를 누르면 읽은 대화가 보이고, 제목을 누르면 그 대화로 가요.',
        image: {
          src: '/images/help/update-2026-11-ai-reference/past-chat.jpg',
          alt: '지난 대화 현장체험학습 안전교육… 참고 안내를 펼쳐 현장체험학습 안전교육 가정통신문 9월 18일과 참고 안 함 버튼이 보이는 화면',
          caption: '참고 안 함을 누르면 앞으로 그 대화는 찾지 않아요',
        },
      },
      {
        title: '4. 언제든 끌 수 있어요',
        description: 'AI 맞춤 설정 → AI가 찾아 쓰는 자료에서 두 기능을 따로 켜고 끌 수 있어요. 끄면 그때부터 모으거나 찾지 않고, 모아 둔 파일은 참고 자료에서 확인하고 지울 수 있어요.',
        image: {
          src: '/images/help/update-2026-11-ai-reference/settings.jpg',
          alt: 'AI가 찾아 쓰는 자료 아래에 채팅에 올린 파일 모아 두기, 지난 대화 찾아보기 스위치와 개인정보처리방침 링크가 있는 설정 화면',
          caption: '켜기 전에 올린 파일도 참고 자료에서 한 번에 모을 수 있어요',
        },
      },
      {
        title: '알아 두세요',
        items: [
          '무료는 직접 적은 텍스트 자료 3개와 따로, 채팅에서 모은 파일을 최근 20개까지 남겨요. PRO는 파일까지 500개를 모아 둬요.',
          'PRO는 채팅 입력창에 폴더를 끌어다 놓으면 안의 문서를 한 번에 자료함에 담아요.',
          '생기부 만들기·상담 대화에 올린 파일은 자동으로 모으지 않아요.',
          '대화를 지우면 그 대화에 올린 첨부도 함께 지워요. 자료함에 담긴 사본은 참고 자료에서 따로 지울 수 있어요.',
        ],
      },
    ],
    links: [
      { label: 'AI 채팅 열기', path: '/chat' },
      { label: 'AI 맞춤 설정', path: '/chat/settings' },
      { label: '개인정보처리방침 변경 안내 (11.4 기본 켜짐)', path: '/help/notice/privacy-policy-update-2026-11-ai-reference-default-on' },
      { label: '개인정보처리방침 변경 안내 (11.2)', path: '/help/notice/privacy-policy-update-2026-11-ai-reference' },
    ],
    popup: {
      tabLabel: '자료 찾아 쓰기',
      slides: [
        { image: '/images/whats-new/update-2026-11-ai-reference/slide-1.jpg', alt: '지난번 파일, 다시 안 올려도 돼요 / 채팅에 올린 파일을 AI가 필요할 때 찾아 써요' },
        { image: '/images/whats-new/update-2026-11-ai-reference/slide-2.jpg', alt: '지난 대화도 이어 써요 / 학생 이름은 가린 채로 필요할 때만 참고해요' },
      ],
    },
  },
  {
    id: 'update-2026-10-school-review',
    date: '2026-10-25',
    title: '생기부 파일, 이제 주고받지 마세요',
    summary: '선생님마다 내가 쓴 글을 직접 올리고, 관리자는 한 화면에서 선생님별 현황과 학교 전체 점검을 봐요.',
    categories: ['saenggibu'],
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '학기 말마다 메신저로 생기부 파일을 받고, 고칠 곳을 보내고, 고친 파일을 또 받던 일을 한 화면에서 끝내요.',
          '담임이 아니어도 돼요. 교과 선생님은 여러 반 세특을, 동아리 선생님은 동아리 글을 직접 올리고, 수정 요청과 메모도 거기서 봐요.',
          '관리자는 선생님별 현황과 함께 학교 전체의 같은 문장, 2026년 감사원 감사에서 문제로 본 수준(세특 51명 이상·행특 한 반 70% 이상), 바이트 초과, 기재요령 문제를 봐요. 대여섯 명뿐인 작은 반도 같은 문장 비율을 따져요.',
          '학교에서 쓰지 않기로 한 표현을 적어 두면 선생님 화면에 보이고 점검에도 함께 들어가요.',
          '담임과 학년 검토 선생님(학년부장 등)은 학생별로 모든 교과 글을 모아 읽고 수정 요청을 남겨요. 글을 고치는 건 언제나 쓴 선생님이에요.',
          '학교 행사처럼 창체에 모두 같게 쓰는 공통 문구는 같은 문장으로 세지 않고, 찾은 표현이 든 글은 학교 전체에 한 번에 수정 요청할 수 있어요.',
          '1·2·3차 점검을 차수별로 기록하고, 확인(인) 칸이 든 점검 기록 PDF를 받아요.',
          '수정 요청을 받은 선생님은 AI로 고쳐 쓰기 초안을 받아 볼 수 있어요. 학생 이름은 AI에 보내지 않아요.',
          '전출·휴직한 선생님 자리는 학교 관리자가 회수해서, 남은 기간을 다음 선생님이 이어 써요.',
          '로그인 없이 가상 학교로 먼저 체험해 볼 수 있어요.',
        ],
      },
      {
        title: '1. 관리자: 우리 학교 기재 지침을 적어요',
        description: '학교 관리자 화면 → 학교 생기부 검토에서 쓰지 않을 표현을 한 줄에 하나씩 적어요. "성실한 학생임 → 맡은 일을 끝까지 해낸 장면"처럼 바꿀 말도 함께 적을 수 있어요.',
        image: {
          src: '/images/help/update-2026-10-school-review/guide.jpg',
          alt: '우리 학교 기재 지침 카드에 선생님께 남길 메모와 쓰지 않을 표현 세 가지, 바꿀 말이 나열되고 고치기 버튼이 있는 화면',
          caption: '저장하면 최근 검토도 다시 점검해요',
        },
      },
      {
        title: '2. 관리자: 선생님별 현황을 한눈에 봐요',
        description: '제출 받기를 켜고 안내 메일을 보내면, 선생님마다 맡은 과목·반, 올린 글 수, 상태(올리기 전 · 검토 중 · 수정 요청 · 다시 올림 · 확인 끝)가 한 줄씩 생겨요.',
        image: {
          src: '/images/help/update-2026-10-school-review/teachers.jpg',
          alt: '선생님 9명 탭 아래에 선생님 이름과 맡은 과목·반, 글 수, 다시 올림·수정 요청·검토 중·올리기 전·확인 끝 상태와 고친 글 보기·확인 끝 버튼이 나열된 화면',
          caption: '안 올린 선생님께 알림 메일을 보낼 수 있어요. 학생 이름은 넣지 않아요',
        },
      },
      {
        title: '3. 관리자: 글을 열어 근거를 보고 수정 요청을 남겨요',
        description: '확인할 글부터 보고, 선생님·반·항목·점검 종류로 좁혀요. 글을 열면 같은 문장이 색칠되고 왜 걸렸는지 나와요. 메모와 함께 수정 요청을 보내면 그 글을 쓴 선생님 화면에 바로 보여요.',
        image: {
          src: '/images/help/update-2026-10-school-review/list.jpg',
          alt: '확인할 글, 수정 요청, 전체 구분과 찾기 칸 아래에 학생별 글과 점검 결과가 나열된 글 목록 화면',
          caption: 'AI 기재요령 검사에는 학생 이름과 번호를 빼고 글만 보내요',
        },
      },
      {
        title: '4. 선생님: 내 생기부 검토에서 올리고, 고칠 글을 봐요',
        description: '오른쪽 위 내 메뉴 → 내 생기부 검토로 들어가요. 쓰던 파일을 그대로 올리면 돼요. 여러 반·여러 과목이 섞여 있어도 다른 선생님 글은 빼고 받고, 몇 개를 뺐는지 알려 드려요.',
        image: {
          src: '/images/help/update-2026-10-school-review/teacher.jpg',
          alt: '고칠 글 5개와 마감일, 고친 파일 올리기 버튼 아래에 내가 맡은 글과 우리 학교 기재 지침이 보이는 선생님 화면',
          caption: '담임을 정해 두면 행동특성·자율·진로는 그 반 담임만 올려요',
        },
      },
      {
        title: '5. 관리자: 고친 글만 다시 보고 마무리해요',
        description: '수정 요청 뒤에 바뀐 글은 "고쳐 올라옴"이 되고 바뀌기 전 글과 비교할 수 있어요. 문제가 없으면 확인했어요로 닫고, 한 선생님 글을 다 봤으면 확인 끝을 눌러요.',
        image: {
          src: '/images/help/update-2026-10-school-review/fixed.jpg',
          alt: '고쳐 올라옴 표시와 고친 글, 바뀌기 전 글 보기, AI 기재요령 검사, 담당 선생님께 남길 메모, 확인했어요 버튼이 있는 글 자세히 보기 화면',
          caption: '엑셀로 받기로 점검 요약과 글 목록을 학교 보관용으로 받을 수 있어요',
        },
      },
      {
        title: '6. 담임·학년부장: 학생별로 모든 글을 모아 읽어요',
        description: '관리자가 학년 검토 선생님을 정하면, 그 선생님과 담임 화면에 "글 함께 보기"가 생겨요. 학생을 누르면 창체·세특·행특을 쓴 선생님 이름과 함께 한 번에 보고, 확인했어요나 메모를 단 수정 요청을 남겨요. 내가 수정 요청한 글이 고쳐 올라오면 맨 위에 모여서, 고치기 전 글과 비교하고 바로 확인할 수 있어요. 학년마다 한 반뿐인 작은 학교는 한 선생님을 모든 학년에 한 번에 넣을 수 있어요.',
        image: {
          src: '/images/help/update-2026-10-school-review/together.jpg',
          alt: '학생 한 명의 자율·동아리·진로·국어 글이 쓴 선생님 이름, 같은 문장 수, 확인했어요·수정 요청 버튼과 함께 차례로 보이는 화면',
          caption: '내가 쓴 글은 다른 선생님이 확인하고, 다른 선생님이 남긴 수정 요청은 덮어쓰지 않아요',
        },
      },
      {
        title: '7. 관리자: 표현 하나로 학교 전체에 수정 요청해요',
        description: '글 목록에서 표현을 찾으면 그 표현이 든 글 수와 예시를 먼저 보여 줘요. 메모를 적어 한 번에 수정 요청하고, 쓰지 않을 표현에도 넣어 다음 파일부터 찾을 수 있어요. 학교 행사처럼 창체에 모두 같게 쓰는 문장은 기재 지침의 공통 문구에 적어 두면 같은 문장으로 세지 않아요.',
        image: {
          src: '/images/help/update-2026-10-school-review/phrase.jpg',
          alt: '체육 용품 표현이 든 글 69개에 수정 요청을 보낸다는 안내와 예시 세 개, 선생님께 남길 메모, 쓰지 않을 표현에도 넣기 선택, 69개 수정 요청 버튼이 있는 화면',
          caption: '잘못 보냈다면 일주일 안에 되돌릴 수 있어요. 이미 수정 요청한 글은 메모를 덮지 않고 건너뛰어요',
        },
      },
      {
        title: '8. 관리자: 차수를 넘기고 점검 기록을 받아요',
        description: '점검 기록에서 1차 점검을 마치면 그 차수의 숫자를 남기고 2차 점검을 시작해요. 확인 끝 표시는 비워 다시 읽게 하고, 수정 요청과 메모는 그대로 이어져요. 점검 기록 PDF에는 차수별 점검과 확인(인) 칸, 선생님별 현황이 들어가요.',
        image: {
          src: '/images/help/update-2026-10-school-review/rounds.jpg',
          alt: '1차·2차 점검 기록과 3차 점검 중 표시, 3차 점검 마치기 버튼, 점검 기록 PDF 받기 버튼이 있는 점검 기록 화면',
          caption: 'PDF에는 학생 이름과 글을 넣지 않아요',
        },
      },
      {
        title: '9. 선생님: 막히면 AI로 고쳐 쓰기 초안을 받아요',
        description: '고칠 글을 열고 "AI로 고쳐 쓰기 초안 받기"를 누르면, 관리자 메모와 점검 결과를 반영한 초안과 바꾼 점을 보여 줘요. 더 넣고 싶은 사실을 적으면 함께 반영하고, 모자란 내용은 질문으로 알려 줘요.',
        image: {
          src: '/images/help/update-2026-10-school-review/draft.jpg',
          alt: '더 넣고 싶은 사실 입력 칸, 다시 만들기 버튼, AI 초안 문장과 바이트 수, 바꾼 점, 이 내용을 알려 주시면 더 좋아져요 질문, 초안 복사 버튼이 있는 화면',
          caption: 'AI가 쓴 문장은 그대로 넣지 말고, 학생을 본 대로 직접 고쳐 쓴 뒤 원본에 넣어 주세요',
        },
      },
      {
        title: '10. 학교 관리자: 전출·휴직 선생님 자리를 회수해요',
        description: '학교 관리자 화면의 선생님 목록에서 자리 회수를 누르고 사유를 골라요. 학교가 드린 기간 중 남은 만큼만 돌려받고, 그 자리는 초대 링크로 다음에 합류하는 선생님이 이어서 써요.',
        image: {
          src: '/images/help/update-2026-10-school-review/reclaim.jpg',
          alt: '한지우 선생님 자리를 회수할까요 안내와 전출·휴직·퇴직·담당 변경·기타 사유 선택, 메모 칸, 취소와 자리 회수 버튼이 있는 창',
          caption: '선생님이 만든 기록은 선생님 계정에 그대로 남고, 안내 메일이 가요',
        },
      },
      {
        title: '꼭 알아 두세요',
        items: [
          'AI 점검 결과는 초안이에요. 최종 판단과 수정은 선생님이 직접 해 주세요.',
          '같은 문장·기재요령·학교 지침 점검은 다시 볼 곳을 좁혀 주는 도구예요. 감사 통과를 보장하지 않아요.',
          '여기서 원본 기록이 바뀌지는 않아요. 원본을 고친 뒤 다시 올리면 고쳐졌는지 확인해 드려요.',
          '학교 생기부 검토는 학교(엔터프라이즈) 요금제(12개월 · 선생님 10명 이상)에 추가 비용 없이 들어 있어요. 금액은 12개월 단체 단가 그대로예요.',
        ],
      },
    ],
    links: [
      { label: '가상 학교로 체험해 보기', path: '/enterprise/school-review' },
      { label: '소개서 받기 (PDF)', path: '/docs/whatquiz-school-review.pdf' },
      { label: '도입 문의하기', path: '/pricing?inquiry=enterprise' },
    ],
  },
  {
    id: 'update-2026-10-behavior-chips',
    date: '2026-10-25',
    title: '행동발달 칩이 300개로 늘고, 장면까지 골라요',
    summary: '특성 칩 314개, 고른 특성 아래 "어떤 모습이었나요?" 장면 칩, 특성 찾기',
    categories: ['saenggibu'],
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '특성 칩이 211개에서 314개로 늘었어요. 선생님들이 직접 많이 만든 "조용함", "활발함", "학급 부회장" 같은 칩도 들어갔어요.',
          '칩을 다시 누르면 학생 특성 칸에서 그 칩만 빠져요.',
          '특성을 고르면 바로 아래에 "어떤 모습이었나요?" 장면 칩이 열려요. 장면을 더하면 문장이 학생마다 더 구체적이에요.',
          '줄에 없는 특성은 "특성 찾기"로 찾아요. "산만", "소심"처럼 떠오르는 말로 찾아도 부드러운 표현의 칩이 나와요.',
          '첫 화면은 그룹마다 한 줄로 정리했어요. 자주 고른 칩은 다음에 들어오면 줄 앞쪽에 보여요.',
        ],
      },
      {
        title: '1. 칩을 누르면 들어가고, 다시 누르면 빠져요',
        description: '그룹마다 많이 쓰는 칩이 한 줄로 보여요. 더 많은 칩은 "더보기"를 누르면 잘하는 점·도와줄 점·내 칩으로 나뉘어 보여요.',
        image: {
          src: '/images/help/update-2026-10-behavior-chips/picker.jpg',
          alt: '학교생활·교우관계·인성·교과학습·개별특성 다섯 줄에 칩과 더보기 버튼이 있고 오른쪽 위에 특성 찾기 버튼이 있는 화면',
          caption: '잘하는 점은 파랑, 도와줄 점은 노랑이에요. 고른 칩에는 체크가 붙어요',
        },
      },
      {
        title: '2. "어떤 모습이었나요?"에서 장면을 골라요',
        description: '특성을 고르면 그 줄 아래에 그 특성이 드러난 장면 4개가 열려요. 장면을 누르면 학생 특성 칸에 함께 들어가요.',
        image: {
          src: '/images/help/update-2026-10-behavior-chips/scenes.jpg',
          alt: '인성 줄의 차분함을 고르자 아래에 갈등 상황에서도 차분히 말함 등 장면 칩 4개가 열린 화면',
          caption: '장면은 한 번에 한 줄만 열리고, × 로 닫을 수 있어요',
        },
        items: [
          '도와줄 점 칩을 고르면 "작은 모둠에서 먼저 발표해 봄"처럼 지도와 변화 장면이 나와요.',
          '장면이 필요 없으면 × 로 닫아요. 여러 번 닫으면 다음부터는 저절로 열지 않아요(특성 찾기로는 찾을 수 있어요).',
        ],
      },
      {
        title: '3. 줄에 없으면 "특성 찾기"로 찾아요',
        description: '오른쪽 위 "특성 찾기"를 누르고 떠오르는 말을 적어요. Enter 를 누르면 첫 번째 칩이 들어가요.',
        image: {
          src: '/images/help/update-2026-10-behavior-chips/search.jpg',
          alt: '특성 찾기 칸에 산만을 적자 집중 유지 도움 필요, 주의 전환이 잦음 칩이 나온 화면',
          caption: '"산만"으로 찾아도 생기부에 쓰기 좋은 표현으로 보여 드려요',
        },
        items: [
          '찾는 칩이 없으면 "그대로 넣기"로 바로 넣거나, "내 칩으로 저장"으로 다음에도 쓸 수 있게 둘 수 있어요.',
        ],
      },
      {
        title: '4. 휴대폰에서는 아래에서 올라오는 창으로 골라요',
        description: '줄마다 옆으로 밀어 칩을 보고, "더보기"나 "찾기"를 누르면 아래에서 창이 올라와요.',
        image: {
          src: '/images/help/update-2026-10-behavior-chips/mobile.jpg',
          alt: '휴대폰 화면 아래에서 올라온 학생 특성 창에 교우관계 칩과 고른 개수, 다 골랐어요 버튼이 있는 화면',
          caption: '다 고르면 "다 골랐어요"를 눌러요',
        },
      },
      {
        title: '이렇게 쓰면 더 좋아요',
        items: [
          '칩은 방향을 잡아 주는 역할이에요. 장면 칩이나 직접 본 일을 한두 개 더하면 그 학생만의 모습이 문장에 더 구체적으로 담겨요.',
        ],
      },
    ],
    links: [{ label: '행동발달 쓰러 가기', path: '/create-saenggibu' }],
  },
  {
    id: 'update-2026-10-artifact-media-v3',
    date: '2026-10-25',
    title: '넣은 그림을 말로 고치고, "이 PPT처럼" 만들어요',
    summary: '그림 고치기·오려 넣기·정확한 그래프와 지도, 마음에 드는 PPT 디자인 따라 하기',
    categories: ['ppt', 'quiz'],
    popup: {
      tabLabel: '그림 고치기',
      slides: [
        { image: '/images/whats-new/update-2026-10-artifact-media-v3/slide-1.jpg', alt: '넣은 그림도 말로 고쳐요. 배경 바꾸기·색칠 도안까지, 원래 그림으로 되돌리기도 돼요.' },
        { image: '/images/whats-new/update-2026-10-artifact-media-v3/slide-2.jpg', alt: '그래프·지도는 정확하게. 값 그대로 그려 PPT에 넣어요.' },
        { image: '/images/whats-new/update-2026-10-artifact-media-v3/slide-3.jpg', alt: '이 PPT처럼 만들어 줘. 마음에 드는 PPT를 올리면 색·배경·제목 모양을 따라요.' },
      ],
    },
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '이미 넣은 그림도 "2번 그림 배경을 밤하늘로 바꿔 줘"처럼 말하면 고쳐요. 원래 그림으로 되돌릴 수도 있어요.',
          '스티커 모음 그림을 올리고 "토끼만 오려서 넣어 줘"라고 하면 그 부분만 오려 넣어요.',
          '그래프·도형·지도는 AI가 어림으로 그리지 않고 값 그대로 정확하게 그려 넣어요.',
          '마음에 드는 PPT·PDF·사진을 올리고 "이 PPT처럼 만들어 줘"라고 하면 색·배경·제목 모양을 따라 만들어요.',
          '학습지 그림은 "크게 해 줘"로 크기를 바꾸고, 색칠 도안으로도 넣을 수 있어요.',
        ],
      },
      {
        title: '1. 넣은 그림을 말로 고쳐요',
        description: '다 만든 PPT에서 "2번 장 토끼 그림을 밤하늘 배경으로 고쳐 줘"처럼 고칠 그림과 바꿀 모습을 말해 주세요.',
        image: {
          src: '/images/help/update-2026-10-artifact-media-v3/picture-edited.jpg',
          alt: '쫑긋쫑긋 하얀 토끼 슬라이드 오른쪽 토끼 그림의 배경이 별이 가득한 밤하늘로 바뀐 화면',
          caption: '토끼는 그대로 두고 배경만 밤하늘로 바꿨어요',
        },
        items: [
          '배경 바꾸기·지우기, 일부 바꾸기·빼기, 색칠 도안·선화로 바꾸기, 밝기·색 바꾸기, 같은 그림체로 하나 더 그리기를 할 수 있어요.',
          '원래 그림은 남겨 두어서 "원래대로 돌려 줘"라고 하면 되돌려요.',
          '고치지 못하면 원래 그림을 그대로 두고 몇 번 그림을 못 고쳤는지 알려 드려요.',
        ],
      },
      {
        title: '2. 스티커 모음에서 하나만 오려 넣어요',
        description: '여러 그림이 모인 스티커 모음을 올리고 "토끼만 오려서 2번 장에 넣어 줘"처럼 말해 주세요.',
        image: {
          src: '/images/help/update-2026-10-artifact-media-v3/sticker-cut.jpg',
          alt: '쫑긋쫑긋 하얀 토끼 슬라이드 오른쪽에 스티커 모음에서 오려 낸 토끼 한 마리만 들어간 화면',
          caption: '스티커 모음에서 토끼만 오려 넣었어요',
        },
        items: [
          '찾는 부분을 못 찾으면 엉뚱한 부분을 넣지 않고 그 자리를 비워 둔 뒤 알려 드려요.',
        ],
      },
      {
        title: '3. 그래프·도형·지도는 값 그대로 정확하게',
        description: '"y=x²-2x-3 그래프를 넣어 줘", "우리나라 지도에서 경상북도를 칠해 줘"처럼 값이나 위치를 말해 주세요.',
        image: {
          src: '/images/help/update-2026-10-artifact-media-v3/exact-map.jpg',
          alt: '시도 이름이 적힌 우리나라 지도에서 경상북도만 파란색으로 칠해진 그림',
          caption: '말한 지역만 칠한 지도를 그려 넣어요',
        },
        items: [
          '도형·좌표 그래프·수직선·자료 그래프·악보·건반·도식·우리나라와 세계 지도를 그릴 수 있어요.',
          '그래프가 틀렸다면 "그래프 모양이 틀렸어, x절편은 -1과 3이야"처럼 바른 값을 함께 말해 주세요.',
        ],
      },
      {
        title: '4. "이 PPT처럼 만들어 줘"',
        description: '마음에 드는 PPT·PDF·사진을 올리고 "첨부한 PPT처럼 같은 디자인으로 만들어 줘"라고 해 주세요.',
        image: {
          src: '/images/help/update-2026-10-artifact-media-v3/reference-deck.jpg',
          alt: '진초록 제목 띠에 우리 동네 봄꽃 관찰 수첩, 연한 초록 바탕에 봄 꽃 관찰하기 제목과 꽃밭 그림이 있는 PPT 표지',
          caption: '본보기의 진초록 제목 띠와 연한 초록 바탕을 따라 만들었어요',
        },
        items: [
          '본보기의 글·로고·사람 사진은 따라 하지 않고, 색·배경·제목 모양·분위기만 따라요.',
          '말로 한 디자인 요청이 있으면 그 말을 먼저 따라요.',
          '학습지는 화면·PDF에서 본보기의 주 색·바탕 색·글자 색을 그대로 써요. 시험지 꾸밈은 인쇄용 흑백이고, 한글·워드 파일은 기본 색으로 받아져요.',
        ],
      },
      {
        title: '5. 이미 만든 PPT도 본보기 디자인으로 바꿔요',
        description: '만든 PPT가 있는 대화에 본보기를 올리고 "첨부한 PPT처럼 디자인만 바꿔 줘"라고 해 주세요.',
        image: {
          src: '/images/help/update-2026-10-artifact-media-v3/restyle-after.jpg',
          alt: '진초록 제목 띠와 연한 초록 바탕으로 디자인이 바뀐 바다 속 생물과 환경 PPT 표지',
          caption: '내용과 장 수는 그대로, 디자인만 본보기를 따라 바꿨어요',
        },
      },
      {
        title: '6. 학습지 그림 크기와 색칠 도안',
        description: '"1번 문항 그림을 크게 해 줘", "2번 문항에 사과나무 색칠 도안을 넣어 줘"처럼 말해 주세요.',
        image: {
          src: '/images/help/update-2026-10-artifact-media-v3/ws-coloring.jpg',
          alt: '왼쪽 채팅에 2번 문항에 사과나무 색칠 도안을 넣어 달라고 하자, 오른쪽 한글 학습지 2번 문항에 선으로만 그린 사과나무 그림이 들어간 화면',
          caption: '2번 문항에 선만 있는 색칠 도안이 들어갔어요',
        },
        items: [
          '그림 크기(작게·보통·크게)는 화면, 한글 파일, 워드 파일에 똑같이 적용돼요.',
          '수직선·그래프·지도 같은 그림도 문항 안에 정확한 그림으로 들어가요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          '그림 고치기·오려 넣기·PPT 정확한 그림은 PRO에서 쓸 수 있어요.',
          '한 번에 만들 수 있는 그림 수를 넘으면 비워 둔 장(문항) 번호를 알려 드려요. "나머지도 넣어 줘"라고 하면 이어서 넣어요.',
          'PPT 전체 디자인을 바꿀 때는 그림을 새로 넣지 않아요. 그림은 따로 말해 주세요.',
        ],
      },
    ],
    links: [
      { label: 'PPT 만들러 가기', path: '/chat?category=ppt_maker' },
      { label: '학습지 만들러 가기', path: '/chat?category=worksheet_gen' },
    ],
  },
  {
    id: 'update-2026-10-artifact-media',
    date: '2026-10-24',
    title: 'PPT·학습지에 내 사진과 실제 사진을 넣어요',
    summary: '올린 사진·실제 사진·AI 그림·문서 속 그림을 원하는 자리에 넣어요.',
    categories: ['ppt', 'quiz'],
    popup: {
      tabLabel: '사진 넣기',
      slides: [
        { image: '/images/whats-new/update-2026-10-artifact-media/slide-1.jpg', alt: '내 사진이 PPT에 그대로. 사진을 올리고 넣을 자리만 말하세요.' },
        { image: '/images/whats-new/update-2026-10-artifact-media/slide-2.jpg', alt: '실제 사진도, 그림도. 실제 사진은 찾아서 출처까지, 그림은 AI가 그려 넣어요.' },
        { image: '/images/whats-new/update-2026-10-artifact-media/slide-3.jpg', alt: 'PDF 속 그림도 꺼내 써요. PDF·한글·PPT 안의 그림을 학습지와 PPT에 바로.' },
      ],
    },
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '사진을 올리고 "2번 장에 넣어 줘"라고 하면 올린 사진 그대로 PPT·학습지에 넣어요.',
          '"해바라기 실제 사진 넣어 줘"라고 하면 실제 사진을 찾아 넣고 사진 출처를 함께 적어요.',
          'PPT에 "캐릭터를 그려 넣어 줘"라고 하면 AI가 그림을 그려 그 장에 넣어요.',
          'PDF·한글·워드·PPT 파일을 올리고 "안에 있는 그림을 넣어 줘"라고 하면 문서 속 그림을 꺼내 써요.',
          '다 만든 초안도 채팅으로 "3번 장에 이 사진 넣어 줘"라고 하면 그 장에 넣어요.',
          'PRO에서 쓸 수 있어요.',
        ],
      },
      {
        title: '1. 사진을 올리고 넣을 자리를 말해요',
        description: 'PPT 만들기나 학습지 생성에서 사진을 올리고, 어느 장(문항)에 넣을지 함께 적어 주세요.',
        image: {
          src: '/images/help/update-2026-10-artifact-media/ppt-request.jpg',
          alt: '강낭콩 관찰 사진 파일을 올리고, 식물의 한살이 PPT 6장을 만들면서 올린 사진은 2번 장에, 해바라기 실제 사진도 찾아 넣고, 마지막 장에는 웃는 강낭콩 캐릭터를 그려 넣어 달라고 적은 화면',
          caption: '사진·실제 사진·그림을 한 번에 부탁해도 돼요',
        },
        items: [
          '사진을 여러 장 올려도 돼요. "첫 번째 사진은 2번 장, 두 번째 사진은 4번 장"처럼 말하면 그대로 넣어요.',
          '한 장에 사진을 4장까지 넣어요.',
        ],
      },
      {
        title: '2. 올린 사진이 그대로 들어가요',
        description: '사진을 새로 그리지 않고 올린 원본 그대로 넣어요. 자리와 크기는 장 디자인에 맞춰 잡아요.',
        image: {
          src: '/images/help/update-2026-10-artifact-media/slide-my-photo.jpg',
          alt: '강낭콩의 싹트기와 초기 관찰 슬라이드 오른쪽에 1일·4일·7일·10일 표시가 붙은 강낭콩 화분 네 개 사진이 들어가고, 아래에 날짜별 강낭콩 생장 관찰 모습이라는 설명이 붙은 화면',
          caption: '올린 강낭콩 관찰 사진이 2번 장에 들어갔어요',
        },
        items: [
          '교과서·시험지처럼 글자가 대부분인 사진은 내용을 읽는 데 쓰고, 넣어 달라고 할 때만 넣어요.',
        ],
      },
      {
        title: '3. 실제 사진은 찾아서 출처까지 적어요',
        description: '"○○ 실제 사진 넣어 줘"라고 하면 자유롭게 쓸 수 있는 사진(위키미디어)을 먼저 찾고, 없으면 인터넷에서 찾아요.',
        image: {
          src: '/images/help/update-2026-10-artifact-media/slide-real-photo.jpg',
          alt: '해바라기의 한살이와 성장 단계 슬라이드 오른쪽에 밭에서 자라는 어린 해바라기 사진이 들어가고, 아래에 해바라기밭의 생장 모습과 사진 출처가 적힌 화면',
          caption: '사진 아래에 사진 출처를 적어요',
        },
        items: [
          '찾은 사진이 찾는 대상과 맞는지 AI가 확인하고 맞는 사진만 넣어요. 인터넷에서 찾은 사진은 워터마크나 광고 글자가 덮인 것을 빼요.',
          '맞는 사진을 못 찾으면 넣지 않아요. 학습지는 그 자리에 그림을 대신 그려 넣어요.',
          '출처 표기는 지우지 말아 주세요. 수업 밖에 올리거나 나눌 때는 사진 출처를 한 번 확인해 주세요.',
        ],
      },
      {
        title: '4. 그림은 AI가 그려 넣어요',
        description: 'PPT에 "웃는 강낭콩 캐릭터를 그려 넣어 줘"처럼 말하면 그 장에 맞는 그림을 그려 넣어요.',
        image: {
          src: '/images/help/update-2026-10-artifact-media/slide-ai-drawing.jpg',
          alt: '단원 마무리 및 식물의 한살이 정리 슬라이드 왼쪽에 발아·영양 생장·개화·결실·다음 세대 화살표 가운데 두 팔을 든 웃는 강낭콩 캐릭터 그림이 들어간 화면',
          caption: '마지막 장에 웃는 강낭콩 캐릭터를 그려 넣었어요',
        },
        items: [
          '학습지는 지금처럼 문항에 필요한 그림을 그려 넣어요.',
        ],
      },
      {
        title: '5. 문서 속 그림도 꺼내 써요',
        description: 'PDF·한글·워드·PPT 파일을 올리고 "PDF 안에 있는 그림을 1번 문항에 넣어 줘"처럼 그림·사진·이미지라는 말을 함께 해 주세요.',
        image: {
          src: '/images/help/update-2026-10-artifact-media/ws-pdf-figure.jpg',
          alt: '왼쪽 채팅에 강낭콩 한살이 PDF로 학습지를 만들고 PDF 안의 한살이 그림을 1번 문항에 넣어 달라고 하자, 오른쪽 한글 학습지 1번 문항에 씨앗·싹·떡잎·꽃·꼬투리로 이어지는 한살이 그림이 들어간 화면',
          caption: 'PDF 안의 한살이 그림을 1번 문항에 그대로 넣었어요',
        },
        items: [
          '한 파일에서 큰 그림부터 4장까지 꺼내요.',
          '글자·표 캡처나 로고·테두리 같은 장식은 빼요.',
          '그림이라는 말이 없으면 지금처럼 문서 내용만 읽어요.',
        ],
      },
      {
        title: '다 만든 뒤에는',
        items: [
          'PPT 받기로 받으면 사진이 따로 된 그림이라 파워포인트에서 옮기거나 크기를 바꿀 수 있어요. 사진 위에 글자 띠처럼 다른 것이 겹친 사진은 배경 그림에 함께 남아요.',
          '다 만든 PPT·학습지도 채팅으로 "3번 장에 이 사진 넣어 줘"라고 하면 그 장만 고쳐요.',
          '사진·그림이 많으면 만드는 데 조금 더 걸려요.',
        ],
      },
    ],
    links: [
      { label: 'PPT 만들러 가기', path: '/chat?category=ppt_maker' },
      { label: '학습지 만들러 가기', path: '/chat?category=worksheet_gen' },
    ],
  },
  {
    id: 'update-2026-10-batch-input',
    date: '2026-10-21',
    title: '평가는 골라 쓰고, 같은 학생 자료는 하나로 합쳐요',
    summary: '다중 생성에서 반에 쓸 평가를 고르고, 나뉘어 들어온 학생 자료를 한 학생으로 합쳐요.',
    categories: ['saenggibu'],
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '평가계획서에 평가가 여러 개 있으면, 이번 반에 쓸 평가를 골라서 써요.',
          '보고서·활동지처럼 한 학생 자료가 나뉘어 들어오면 한 학생으로 합쳐서 생기부를 하나만 만들어요.',
          '1명 생성에 반 전체가 담긴 행동발달·창체 파일을 올리면, 그 파일로 모든 학생을 한 번에 만들 수 있어요.',
        ],
      },
      {
        title: '1. 평가계획서에서 이번 반에 쓸 평가를 골라요',
        description: '다중 생성에 평가계획서를 올리면 들어 있는 평가를 찾아서 보여 줘요. 이번 반에 쓸 평가를 누르면 그 평가 내용만 넣어 써요.',
        image: {
          src: '/images/help/update-2026-10-batch-input/plan-pick.jpg',
          alt: '평가 3개를 찾았어요 안내 아래에 과학 탐구 보고서 작성, 과학 실험 활동지 작성, 과학 모둠 발표, 모두 합쳐서 쓰기, 다른 파일 올리기 버튼이 있는 화면',
          caption: '여러 평가를 함께 쓰려면 "모두 합쳐서 쓰기"를 누르세요',
        },
        items: [
          '평가를 고르지 않으면 생성을 시작하기 전에 먼저 골라 달라고 알려 줘요.',
        ],
      },
      {
        title: '고른 평가는 언제든 바꿀 수 있어요',
        description: '고른 평가 이름이 파일 아래에 보여요. "다른 평가로 바꾸기"를 누르면 다시 고를 수 있어요.',
        image: {
          src: '/images/help/update-2026-10-batch-input/plan-picked.jpg',
          alt: '과학_평가계획.docx 파일 아래에 고른 평가 과학 탐구 보고서 작성이 표시되고 다른 평가로 바꾸기, 삭제 버튼이 있는 화면',
          caption: '아래 칸에서 넣을 내용을 직접 고쳐도 돼요',
        },
      },
      {
        title: '2. 같은 학생 자료는 한 학생으로 합쳐요',
        description: '같은 이름이 두 번 이상 나오면 학생 목록 위에 알려 줘요. 합칠 학생을 확인하고 "합치기"를 누르세요. 동명이인은 이름을 눌러서 빼면 따로 남아요.',
        image: {
          src: '/images/help/update-2026-10-batch-input/same-student.jpg',
          alt: '같은 이름이 두 번 이상 나온 학생이 3명 있어요 카드. 김가온 2번과 박서하 2번은 선택되고 이도윤 2번은 빠져 있으며 고른 2명 합치기, 모두 따로 두기 버튼이 있는 화면',
          caption: '김*수처럼 이름 일부를 가린 학생은 다른 학생일 수 있어서 처음에는 빼 둬요',
        },
      },
      {
        title: '합친 학생은 자료가 한 칸에 모여요',
        description: '합친 학생에게는 "자료 2개 합침"이 보이고, 원문 칸에 두 자료가 차례로 들어가요. 잘못 합쳤다면 바로 뜨는 "실행 취소"를 누르세요.',
        image: {
          src: '/images/help/update-2026-10-batch-input/merged-student.jpg',
          alt: '김가온 학생 카드에 자료 2개 합침 204자가 표시되고, AI가 참고할 원문 칸에 학번과 이름, 탐구 보고서 내용이 이어서 들어간 화면',
          caption: '원문은 생성 전에 직접 고칠 수 있어요',
        },
      },
      {
        title: '3. 반 전체 파일로 한 번에 만들어요',
        description: '1명 생성에서 행동발달이나 창체 파일을 올렸는데 여러 학생이 들어 있으면, 학생 이름 아래에 "이 파일로 N명 한 번에 만들기"가 보여요. PRO에서 쓸 수 있어요.',
        image: {
          src: '/images/help/update-2026-10-batch-input/file-offer.jpg',
          alt: '행동발달_관찰기록.docx 파일에 학생 5개가 표시되고, 한별·서준·지우·하늘·도담 이름 아래에 이 파일로 5명 한 번에 만들기 버튼이 있는 화면',
          caption: '1명만 쓰려면 지금처럼 학생 이름을 누르면 돼요',
        },
      },
      {
        title: '파일을 다시 올리지 않아도 돼요',
        description: '버튼을 누르면 다중 생성으로 넘어가고, 파일에서 찾은 학생이 그대로 들어가 있어요. 종류와 분량을 확인하고 바로 만들면 돼요.',
        image: {
          src: '/images/help/update-2026-10-batch-input/batch-from-file.jpg',
          alt: '다중 생성 화면. 종류 행동발달, 목표 바이트 800B, 단일 생성에서 올린 파일 학생 5명, 5명 학생 정보를 찾았어요와 한별 학생의 원문이 보이는 화면',
          caption: '창체 파일의 학생 표시 줄은 빼고 원문만 넣어요',
        },
      },
      {
        title: '알아 두세요',
        items: [
          '생성을 멈추고 이전으로 돌아가도 학생 목록은 그대로 남아 있어요.',
          '한 학생 원문이 15,000자를 넘으면 앞부분만 생성에 써요. 꼭 넣을 내용은 원문 칸 앞쪽에 두세요.',
        ],
      },
    ],
    links: [
      { label: '생기부 다중 생성 열기', path: '/batch-saenggibu' },
      { label: '생기부 1명 생성 열기', path: '/create-saenggibu' },
    ],
    popup: {
      tabLabel: '다중 생성',
      slides: [
        { image: '/images/whats-new/update-2026-10-batch-input/slide-1.jpg', alt: '반에 쓸 평가만 골라요. 평가계획서에 평가가 여러 개면 이번 반 평가만 골라 써요.' },
        { image: '/images/whats-new/update-2026-10-batch-input/slide-2.jpg', alt: '같은 학생 자료는 하나로. 보고서·활동지를 따로 올려도 한 학생으로 합쳐요.' },
        { image: '/images/whats-new/update-2026-10-batch-input/slide-3.jpg', alt: '명단 파일로 반 전체를. 단일 생성에 올린 파일로 모든 학생을 한 번에 만들어요.' },
      ],
    },
  },
  {
    id: 'update-2026-10-edu-news',
    date: '2026-10-21',
    title: '매일 아침 8시, 교육 뉴스를 정리해 드려요',
    summary: '선생님께 필요한 교육 소식만 골라 3분이면 읽게 정리했어요. 메일로도 받아 볼 수 있어요.',
    categories: ['etc'],
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '매일 아침 8시에 교육 정책, 학교 현장, 해외 교육 소식을 골라 짧게 정리해 올려요.',
          '기사마다 선생님이 챙길 점과 원문 링크를 함께 드려요.',
          '왓퀴즈 공지나 업데이트가 있는 날은 함께 담아요.',
          '정치 기사는 넣지 않아요.',
        ],
      },
      {
        title: '1. AI 채팅 첫 화면에서 바로 열어요',
        description: 'AI 채팅 첫 화면에 오늘의 교육 뉴스 제목이 한 줄로 보여요. 누르면 오늘 뉴스로 가요.',
        image: {
          src: '/images/help/update-2026-10-edu-news/chat-card.jpg',
          alt: 'AI 채팅 첫 화면의 "선생님, 오늘 어떤게 급하세요?" 아래에 오늘의 교육 뉴스 제목과 메일로 받기 버튼, 닫기 버튼이 있는 한 줄 카드',
          caption: '보고 싶지 않으면 X를 눌러 30일 동안 숨길 수 있어요',
        },
      },
      {
        title: '2. 요약부터 읽고, 궁금한 기사만 펼쳐요',
        description: '맨 위의 "바쁜 선생님을 위한 요약"만 읽어도 그날 소식을 알 수 있어요.',
        image: {
          src: '/images/help/update-2026-10-edu-news/news-top.jpg',
          alt: '교육 뉴스 화면 위쪽에 바쁜 선생님을 위한 요약 두 줄과, 오늘의 주요 뉴스 카드에 핵심 숫자, 선생님이 챙길 점, 원문 보기 링크가 있는 화면',
          caption: '원문 보기를 누르면 기사 원문으로 가요',
        },
      },
      {
        title: '3. 메일로 받고 싶다면',
        description: '뉴스 맨 아래에 이메일을 적고 두 가지 동의를 체크한 뒤 "메일로 받기"를 누르세요.',
        image: {
          src: '/images/help/update-2026-10-edu-news/subscribe.jpg',
          alt: '이메일 주소 입력칸, 개인정보 수집·이용 동의와 광고성 정보(이메일) 수신 동의 체크박스, 메일로 받기 버튼이 있는 신청 화면',
          caption: '신청하면 다음 날 아침부터 보내 드려요',
        },
        items: [
          '왓퀴즈에 로그인한 이메일로 신청하면 확인 메일 없이 바로 신청돼요.',
          '다른 이메일이면 확인 메일의 버튼을 한 번 눌러 주세요.',
          '메일 맨 아래의 수신거부를 누르면 바로 그만 받을 수 있어요.',
        ],
      },
    ],
    links: [
      { label: '오늘 뉴스 보기', path: '/news' },
    ],
    popup: {
      tabLabel: '교육 뉴스',
      slides: [
        { image: '/images/whats-new/update-2026-10-edu-news/slide-1.jpg', alt: '아침 교육 뉴스가 왔어요. 매일 아침 8시, 정책·학교·해외 소식을 한 번에.' },
        { image: '/images/whats-new/update-2026-10-edu-news/slide-2.jpg', alt: '3분이면 다 읽어요. 핵심만 짧게 정리하고 원문 링크도 함께 드려요.' },
        { image: '/images/whats-new/update-2026-10-edu-news/slide-3.jpg', alt: "메일로도 받아요. 뉴스 맨 아래 '메일로 받기', 다음 날 아침부터 보내드려요." },
      ],
    },
  },
  {
    id: 'update-2026-10-argon',
    date: '2026-10-20',
    title: 'Gemini 4 Argon을 쓸 수 있어요',
    summary: 'AI 채팅에서 깊이 생각해서 답하는 Gemini 4 Argon을 골라 쓸 수 있어요. PRO에서 써 보세요.',
    categories: ['chat'],
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          'AI 채팅 모델 목록에 Gemini 4 Argon이 들어왔어요.',
          '깊이 생각해서 답하는 모델이에요. 검색해서 정리하는 질문이나 여러 단계를 거치는 일에 잘 맞아요.',
          'PRO에서 쓸 수 있어요. 따로 설정할 것은 없어요.',
        ],
      },
      {
        title: '1. 채팅 위에서 Gemini 4 Argon을 골라요',
        description: 'AI 채팅 화면 위쪽의 모델 이름을 누르면 Gemini 3.1 Pro 아래에 Gemini 4 Argon이 보여요.',
        image: {
          src: '/images/help/update-2026-10-argon/picker.jpg',
          alt: '모델 선택 목록에 빠른 모드, 고급 모드, GPT-6.1, Gemini 3.1 Pro, Gemini 4 Argon, Gemini 3.8 Flash, Claude Sonnet 5.5가 보이고 Gemini 4 Argon이 선택된 화면',
          caption: '목록에서 Gemini 4 Argon을 누르세요',
        },
      },
      {
        title: '2. 수업 자료를 표로 받아 봐요',
        description: '"중학교 2학년 과학 \'물질의 상태 변화\' 수업 도입 질문 3개를 예상 학생 답과 함께 표로 짧게 정리해 줘"처럼 말해 보세요.',
        image: {
          src: '/images/help/update-2026-10-argon/argon-answer.jpg',
          alt: 'Gemini 4 Argon이 물질의 상태 변화 수업 도입 질문 3개와 예상 학생 답을 표로 정리하고 관련 사진을 함께 보여 주는 화면',
          caption: '학년, 과목, 분량을 함께 적으면 더 알맞게 답해요',
        },
        items: [
          '답을 자세히 쓰는 편이에요. 짧게 받고 싶으면 "짧게"라고 함께 적어 주세요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          '답을 자세히 쓰느라 다른 모델보다 끝나는 데 시간이 조금 더 걸릴 수 있어요. 가벼운 질문은 빠른 모드가 편해요.',
          'AI가 쓴 날짜, 요일, 숫자는 틀릴 수 있어요. 보내기 전에 꼭 한 번 확인해 주세요.',
        ],
      },
    ],
    links: [
      { label: 'AI 채팅 열기', path: '/chat?category=pro_ai' },
    ],
    popup: {
      tabLabel: 'Argon',
      slides: [
        { image: '/images/whats-new/update-2026-10-argon/slide-1.jpg', alt: 'Gemini 4 Argon이 들어왔어요. 깊이 생각해서 꼼꼼하게 답해요.' },
        { image: '/images/whats-new/update-2026-10-argon/slide-2.jpg', alt: '찾고 정리하는 일에 딱. 검색해서 표로 정리하고 여러 단계도 차근차근.' },
        { image: '/images/whats-new/update-2026-10-argon/slide-3.jpg', alt: 'PRO에서 바로 써요. 채팅 위 모델 이름을 누르고 Gemini 4 Argon을 고르세요.' },
      ],
    },
  },
  {
    id: 'update-2026-10-class-check',
    date: '2026-10-19',
    title: '같은 문장은 찾아 주고, 학생 메모는 생기부로 이어져요',
    summary: '반 전체에서 겹치는 문장을 고칠 학생만 알려 주고, 학생마다 남긴 메모로 바로 생기부를 쓸 수 있어요.',
    categories: ['saenggibu'],
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '다중 생성 결과와 검사기에서 학생끼리 같은 문장·거의 같은 문장을 찾아, 고칠 학생만 알려 줘요.',
          '학생마다 관찰 메모와 임원·진로희망을 남겨 두고, 그대로 생기부 초안에 넣을 수 있어요.',
          '1명씩 쓴 생기부도 명단의 학생에게 담겨 학생별 기록에 모여요.',
          '2학기 행동특성은 1학기 글과 합쳐 한 칸을 넘지 않게 분량을 맞춰요.',
          '다시 요청한 내용을 고치거나 지울 수 있고, "다음 학생 쓰기"로 바로 이어 써요.',
        ],
      },
      {
        title: '1. 반 전체에서 겹치는 문장을 찾아 줘요',
        description: '다중 생성이 끝나면 결과 위에 반 전체 점검이 보여요. 같은 문장마다 한 명은 그대로 두고 나머지만 고치면 되도록, 고칠 학생만 골라 줘요. 학생 글에는 겹친 문장에 밑줄이 그어져요.',
        image: {
          src: '/images/help/update-2026-10-class-check/class-check.jpg',
          alt: '다른 학생과 겹치는 문장 1곳 카드. 반 70% 넘게 같은 문장이에요 경고, 겹치지 않게 9명 고치기 버튼, 이준서·박서연·최지우·정유나·강도윤 학생과 고치기 버튼이 있는 화면',
          caption: '"겹치지 않게 9명 고치기"를 누르면 겹친 문장만 학생 자료에 맞게 다시 써요',
        },
      },
      {
        title: '2. 검사기에서도 반 전체를 함께 봐요',
        description: '여러 학생을 한 번에 검사하면, 맞춤법·기재요령과 함께 학생끼리 겹치는 문장도 알려 줘요. 엑셀로 받으면 "겹침" 칸에 바꿀 문장이 적혀 있어요.',
        image: {
          src: '/images/help/update-2026-10-class-check/inspector-class-check.jpg',
          alt: '검사기 결과의 다른 학생과 겹치는 문장 2곳 카드. 같은 문장 1, 거의 같은 문장 1과 고칠 학생 3명이 보이는 화면',
          caption: '보기를 누르면 그 학생 결과로 바로 이동해요',
        },
      },
      {
        title: '3. 학생마다 메모를 남겨 두세요',
        description: '학급 관리 › 학생별 기록에서 학생을 누르면 임원·진로희망과 메모를 남길 수 있어요. 영역은 내용을 보고 미리 골라 둬요.',
        image: {
          src: '/images/help/update-2026-10-class-check/student-notes.jpg',
          alt: '강도윤 학생 화면. 임원 학급 부회장 2학기, 진로희망 환경 공학자, 메모 2개와 이 학생 생기부 쓰기 버튼이 있는 화면',
          caption: '수상·어학시험처럼 생기부 문장에 쓸 수 없는 내용은 따로 알려 줘요',
        },
      },
      {
        title: '4. 메모로 바로 생기부를 써요',
        description: '"이 학생 생기부 쓰기"를 누르면 메모와 임원·진로희망이 입력칸에 들어간 채로 열려요. 생기부에 쓸 수 없는 문장은 빼고 넣어요.',
        image: {
          src: '/images/help/update-2026-10-class-check/memo-prefill.jpg',
          alt: '생기부 1명 생성 화면. 학생 특성 칸에 임원, 진로희망, 메모가 들어가 있고 아래에 학생 강도윤, 메모 2개 넣음이 보이는 화면',
          caption: '다 쓰면 이 학생 기록에 자동으로 담겨요',
        },
      },
      {
        title: '5. 1명씩 쓸 때도 명단의 학생을 골라요',
        description: '다 쓴 뒤 마음에 드는 글 위의 "담기"를 누르고 학생을 고르면, 그 글이 학생 기록에 담겨요. 담긴 글에는 학생 이름이 표시돼요.',
        image: {
          src: '/images/help/update-2026-10-class-check/single-pick.jpg',
          alt: '생기부 결과 기본과 버전 2 카드. 기본 카드에는 담기 버튼이, 버전 2 카드에는 박서연 학생에게 담겼다는 체크 표시가 있는 화면',
          caption: '"다음 학생 쓰기"를 누르면 반 공통 입력은 두고 학생 입력만 비워요',
        },
      },
      {
        title: '6. 학생별 기록에서 반 전체를 점검해요',
        description: '학생별 기록 화면의 반 전체 점검은 왓퀴즈에서 쓴 생기부를 영역별로 학생끼리 맞대어 봐요.',
        image: {
          src: '/images/help/update-2026-10-class-check/roster-class-check.jpg',
          alt: '반 전체 점검 카드. 교과세특 과학 4명 중 같은 문장 1곳, 3명만 고치면 돼요와 행동특성 5명은 학생마다 다른 문장으로 써졌어요가 보이는 화면',
          caption: '나이스에서 고친 최종본은 생기부 검사기에 넣어 점검하세요',
        },
      },
      {
        title: '7. 2학기 행동특성은 남은 분량으로 써요',
        description: '2학기 명단으로 다중 생성을 하면, 1학기에 쓴 행동특성 글 길이를 보고 합쳐도 한 칸을 넘지 않게 분량을 맞춰요.',
        image: {
          src: '/images/help/update-2026-10-class-check/prior-semester.jpg',
          alt: '1학기 글 분량만큼 줄여 쓰기 체크. 4명 1학기 글 있음, 1학기 글이 176바이트쯤이라 합쳐도 넘치지 않게 1200바이트로 2학기를 써요라는 안내가 있는 화면',
          caption: '체크를 끄면 원래 분량으로 써요',
        },
      },
      {
        title: '8. 다시 요청한 내용을 고치거나 지워요',
        description: '"이전 요청도 함께 반영해요" 목록에서 요청을 눌러 고치거나 ×로 지울 수 있어요. 지운 요청은 되돌릴 수 있어요.',
        image: {
          src: '/images/help/update-2026-10-class-check/regen-chain.jpg',
          alt: '이전 요청도 함께 반영해요 목록. 300자 이내로 짧게 써 주세요, 도서부 활동을 더 구체적으로 드러내 주세요 두 요청 옆에 고치기·지우기 버튼과 모두 지우기가 있는 화면',
          caption: '다음에 다시 만들 때 고친 목록대로 반영해요',
        },
      },
      {
        title: '알아 두세요',
        items: [
          '겹침 점검은 같은 반 학생의 글끼리만 비교해요. 짧은 표현이나 활동 이름이 같은 것은 괜찮고, 문장 전체가 같거나 거의 같을 때만 알려 줘요.',
          '학생 메모와 임원·진로희망은 선생님 본인만 볼 수 있어요. "이 학생 생기부 쓰기"로 넣을 때만 AI에 보내요.',
          '건강·장애·가정환경 같은 민감한 내용은 메모에 적지 마세요.',
          '명단을 지우면 그 명단에만 있던 학생의 메모도 함께 지워져요.',
        ],
      },
    ],
    links: [
      { label: '생기부 쓰러 가기', path: '/create-saenggibu' },
      { label: '학급 관리로 가기', path: '/classes' },
    ],
  },
  {
    id: 'update-2026-10-student-records',
    date: '2026-10-18',
    title: '학생별로 모인 기록으로 생기부를 써요',
    summary: '채점·생기부·제출 기록이 학생마다 모이고, 한 명이나 반 전체 생기부를 바로 쓸 수 있어요.',
    categories: ['saenggibu', 'scoring'],
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '학급 관리에 저장한 명단으로, 올해 채점·생기부·제출 기록을 학생마다 모아 보여 줘요.',
          '학생 한 명을 눌러 그 학생의 채점 기록으로 교과세특 초안을 쓸 수 있어요.',
          '채점 기록이 있는 학생 전체를 한 번에 생기부 다중 생성으로 넘길 수 있어요.',
        ],
      },
      {
        title: '1. 학급 관리에서 "학생별 기록 보기"를 눌러요',
        description: '오른쪽 위 프로필의 "학급 관리"에서 명단을 열면 맨 위에 있어요. 지난 학년도 명단도 볼 수 있어요.',
        image: {
          src: '/images/help/update-2026-10-student-records/classes-entry.jpg',
          alt: '2학년 3반 명단 카드. 이 명단으로 시작하기 아래에 학생별 기록 보기 버튼이 있는 화면',
          caption: '명단을 열고 학생별 기록 보기를 누르세요',
        },
      },
      {
        title: '2. 반 학생마다 모인 기록을 한눈에 봐요',
        description: '학생 이름 옆에 채점·생기부·제출 기록 수가 보여요. 반 전체 생기부도 여기서 바로 시작해요.',
        image: {
          src: '/images/help/update-2026-10-student-records/class-students.jpg',
          alt: '2학년 3반 학생 8명 목록. 학생마다 채점 2, 생기부 1, 제출 1 같은 기록 수가 있고 위에 7명 생기부 쓰기 버튼이 있는 화면',
          caption: '"7명 생기부 쓰기"를 누르면 채점 기록이 있는 학생 모두를 한 번에 넘겨요',
        },
      },
      {
        title: '3. 학생 한 명의 기록으로 생기부를 써요',
        description: '학생을 누르면 채점한 과제와 점수, 잘한 점이 날짜순으로 보여요. "생기부 쓰기"를 누르면 이 기록을 근거로 초안을 만들어요.',
        image: {
          src: '/images/help/update-2026-10-student-records/student-records.jpg',
          alt: '한아현 학생의 모은 기록. 토론 개요서 9/10점, 독서 감상문 7/10점, 논설문 쓰기 7/10점 채점 기록과 생기부 쓰기 버튼이 있는 화면',
          caption: '채점 기록 3개를 근거로 교과세특 초안을 만들어요',
        },
      },
      {
        title: '4. 생기부 다중 생성에서 확인하고 만들어요',
        description: '학생들이 명단과 맞춰진 채로 들어와요. 종류와 분량을 고른 뒤 만들기를 누르세요.',
        image: {
          src: '/images/help/update-2026-10-student-records/saenggibu-review.jpg',
          alt: '2학년 3반 학생별 기록, 학생 7명. 7명 학생 정보를 찾았어요, 7명 모두 맞췄어요가 보이는 생기부 다중 생성 화면',
          caption: '점수 문장은 빼고 관찰한 내용만 근거로 넘겨요',
        },
      },
      {
        title: '알아 두세요',
        items: [
          '이름이 명단과 같거나 저장한 별칭인 기록만 모아요. 한 글자 다른 이름은 다른 학생일 수 있어 모으지 않아요.',
          '같은 이름의 학생이 다른 반 명단에도 있으면, 어느 반 기록인지 확실할 때만 모아요.',
          '생기부 1명 생성 기록은 학생 이름을 저장하지 않아서 모이지 않아요.',
          '기록은 선생님 본인만 볼 수 있어요.',
        ],
      },
    ],
    links: [{ label: '학급 관리로 가기', path: '/classes' }],
  },
  {
    id: 'update-2026-10-saenggibu',
    date: '2026-10-17',
    title: '생기부 시즌, 반 전체를 한 번에 챙겨요',
    summary: '학급 관리로 우리 반 명단을 한 곳에서, 반 전체 점검과 채점 결과로 세특 쓰기까지 한 번에 돼요.',
    categories: ['saenggibu', 'scoring'],
    popup: {
      tabLabel: '생기부 시즌',
      slides: [
        { image: '/images/whats-new/update-2026-10-saenggibu/slide-1.jpg', alt: '우리 반 명단, 한 번만. 저장해 두면 다음 파일부터 이름을 알아서 맞춰요.' },
        { image: '/images/whats-new/update-2026-10-saenggibu/slide-2.jpg', alt: '반 전체를 한 번에 점검. 비슷한 글은 골라서 이 학생만 다르게 고쳐요.' },
        { image: '/images/whats-new/update-2026-10-saenggibu/slide-3.jpg', alt: '채점 결과로 세특 쓰기. 채점 기록을 골라 바로 불러와요.' },
      ],
    },
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '다중 생성이나 서술형 채점에서 우리 반 명단을 한 번 저장하면, 다음에 올리는 파일은 학생 이름을 알아서 맞춰요.',
          '프로필 메뉴의 "학급 관리"에서 명단을 고치고, 2학기·새 학년으로 이어 쓸 수 있어요.',
          '제출방에 명단을 연결하면 아직 안 낸 학생이 바로 보여요.',
          '다 만든 뒤 반 전체를 한 번에 점검해서, 다르게 쓰면 좋은 학생만 골라 보여 줘요.',
          '서술형 채점 결과를 불러와서 교과세특을 쓸 수 있어요.',
          '예전에 쓴 생기부를 붙여 넣기만 하면 내 문체가 바로 저장돼요. 공통 스타일 1개는 무료예요.',
          '분량을 더 정확하게 맞추고, AI가 자주 쓰는 뻔한 표현을 줄였어요.',
        ],
      },
      {
        title: '1. 우리 반 명단을 한 번 저장해요',
        description: '다중 생성이나 여러 명 채점이 끝나면 결과 아래에 "이 반을 학생별로 모아둘까요?"가 보여요. 모아두기를 누르면 끝이에요.',
        image: {
          src: '/images/help/update-2026-10-saenggibu/roster-save.jpg',
          alt: '이 반 4명을 학생별로 모아둘까요? 문구와 모아두기, 닫기 버튼이 있는 결과 화면 카드',
          caption: '모아두기를 한 번 누르면 명단이 저장돼요',
        },
      },
      {
        title: '2. 다음 파일부터 이름을 알아서 맞춰요',
        description: '학기가 바뀌어 새 파일을 올려도 저장한 명단으로 학생을 맞춰요. 맞추지 못한 학생만 확인해 주세요.',
        image: {
          src: '/images/help/update-2026-10-saenggibu/roster-match.jpg',
          alt: '지난번 1학년 3반 명단으로 맞췄어요, 8명 중 6명을 맞췄어요. 2명만 확인해 주세요. 최지후는 최지우로 바꾸기, 한예린은 명단에서 고르기 버튼이 있는 화면',
          caption: '오타로 보이는 이름은 명단 속 이름으로 바꿀지 물어봐요',
        },
        items: [
          '비슷한 이름이 없으면 "명단에서 고르기"로 맞는 학생을 직접 골라요.',
          '새로 온 학생이면 "그대로 두기"를 누르세요. 파일에 적힌 이름 그대로 써요.',
        ],
      },
      {
        title: '3. 학급 관리에서 명단을 고치고 이어 써요',
        description: '오른쪽 위 프로필을 눌러 "학급 관리"로 들어가세요. 저장한 명단을 학년도·학기별로 모아 보여 줘요.',
        image: {
          src: '/images/help/update-2026-10-saenggibu/classes.jpg',
          alt: '학급 관리 화면. 2026학년도 2학기 3-1 과학, 1학기 2학년 3반, 2025학년도 작년 1학년 2반 명단 카드와 새 명단 만들기 버튼',
          caption: '명단을 열면 이름을 고치고, 학생을 더하거나 빼고, 순서를 바꿀 수 있어요',
        },
        items: [
          '"새 명단 만들기"에 나이스나 엑셀 명렬표를 그대로 붙여 넣으면 번호는 빼고 이름만 골라요.',
          '1학기 명단은 "2학기로 이어 쓰기", 지난 학년도 명단은 "올해 명단으로 가져오기"로 한 번에 옮겨요.',
          '12월부터 2월까지는 새 학년 명단을 미리 만들어 둘 수 있어요. 3월부터 그 명단으로 이름을 맞춰요.',
          '"명렬표 엑셀 받기"를 누르면 번호·이름이 채워진 엑셀을 받아 다중 생성에 바로 쓸 수 있어요.',
          '기록에서 학생 이름을 고치면, 다음부터는 고치기 전 이름으로 올라와도 그 학생으로 맞춰요.',
        ],
      },
      {
        title: '4. 제출방에서 안 낸 학생을 바로 봐요',
        description: '제출방 화면에서 저장한 명단을 골라 연결하세요. 낸 학생 수, 아직 안 낸 학생, 이름을 다르게 적은 학생을 보여 줘요.',
        image: {
          src: '/images/help/update-2026-10-saenggibu/room-roster.jpg',
          alt: '2학년 3반 6명 중 3명 냈어요. 아직 안 낸 학생 3명 이준서 정하준 한예린, 이름을 다르게 적은 학생 최지후에서 최지우, 명단에 없는 이름 홍길동',
          caption: '학생 화면에는 명단이 보이지 않아요',
        },
      },
      {
        title: '5. 반 전체를 한 번에 점검해요',
        description: '다중 생성이 끝나면 결과 위에 점검표가 보여요. 첫머리가 같은 글, 서로 비슷한 글, 뻔한 표현이 많은 글만 골라 알려 줘요.',
        image: {
          src: '/images/help/update-2026-10-saenggibu/class-check.jpg',
          alt: '다르게 쓰면 좋은 학생 2명, 최지우 상투어가 9개예요, 강도윤 상투어가 6개예요, 각각 이 학생만 다르게 버튼이 있는 화면',
          caption: '걸린 학생만 보여 줘요. 모두 괜찮으면 "학생마다 다르게 잘 써졌어요"라고 알려 줘요',
        },
      },
      {
        title: '6. "이 학생만 다르게"로 한 명씩 고쳐요',
        description: '버튼을 누르면 내용은 그대로 두고 표현만 바꾼 수정안을 만들어요. 읽어 보고 "적용하기"를 눌러야 바뀌어요.',
        image: {
          src: '/images/help/update-2026-10-saenggibu/make-different.jpg',
          alt: '다른 학생 글과 겹치지 않게 다시 써 달라는 요청과 그 아래 수정안, 수정하기·적용하기·취소 버튼이 있는 화면',
          caption: '수정안이 마음에 들면 적용하기, 아니면 취소를 누르세요',
        },
        items: [
          '적용하면 점검표가 바로 다시 계산돼요.',
          '요청 칸에 "활동은 그대로, 문장만 짧게"처럼 직접 적어도 돼요.',
        ],
      },
      {
        title: '7. 채점한 결과로 교과세특을 써요',
        description: '다중 생성에서 교과세특·세특(고)을 고르면 "채점 결과 불러오기"가 보여요. 이번 학기 채점 기록을 여러 개 골라도 학생별로 모아 줘요.',
        image: {
          src: '/images/help/update-2026-10-saenggibu/scoring-import-modal.jpg',
          alt: '채점 결과 불러오기 창에 논설문 쓰기, 실험 보고서, 독서 감상문 채점 기록이 체크박스로 나열된 화면',
          caption: '쓸 채점 기록을 고르고 불러오기를 누르세요',
        },
        items: [
          '잘한 점과 보완할 점, 학생 답안 속 표현을 근거로 써요.',
          '점수는 생기부 문장에 넣지 않아요.',
        ],
      },
      {
        title: '8. 채점 기록에서 바로 넘어갈 수도 있어요',
        description: '채점 기록에서 여러 개를 고르면 "교과세특 쓰기" 버튼이 생겨요. 누르면 고른 기록을 담은 채로 생기부 만들기로 넘어가요.',
        image: {
          src: '/images/help/update-2026-10-saenggibu/scoring-history.jpg',
          alt: '채점 기록 3개를 선택한 상태에서 선택 해제, 삭제, 교과세특 쓰기(3), 답안·결과 엑셀 버튼이 보이는 화면',
          caption: '고른 개수만큼 "교과세특 쓰기 (3)"처럼 보여요',
        },
      },
      {
        title: '9. 내 스타일, 붙여 넣기만 하면 돼요',
        description: '내 스타일 화면 맨 위 칸에 예전에 쓴 생기부를 2~3개 붙여 넣고 "내 스타일로 바로 적용"을 누르세요. 다음 생성부터 그 문체로 써요.',
        image: {
          src: '/images/help/update-2026-10-saenggibu/mystyle-quick.jpg',
          alt: '예전에 쓴 생기부를 붙여넣어 주세요 칸에 생기부 두 개를 붙여 넣고 내 스타일로 바로 적용 버튼이 있는 화면',
          caption: '학생 이름은 지우고 붙여 넣어 주세요',
        },
        items: [
          '공통 스타일 1개는 무료로 저장해 모든 생성에 쓸 수 있어요. 종류별로 따로 정하는 건 PRO에서 할 수 있어요.',
          '생기부 만들기 화면에 "✓ 내 스타일 적용 중"이 보이면 적용된 거예요. 옆 스위치로 잠깐 끌 수 있어요.',
        ],
      },
      {
        title: '보이지 않게 좋아진 점',
        items: [
          '정한 바이트를 넘치면 정보가 적은 문장부터 줄여서 분량을 맞춰요. 없던 내용을 덧붙이지 않아요.',
          '"~하는 모습을 보임"처럼 AI가 자주 쓰는 뻔한 표현이 몰린 문장만 골라 자연스럽게 바꿔요.',
          '첨부 자료가 길면 이 학생의 핵심 활동을 먼저 골라서 써요. 한 명씩 만들 때도, 다중 생성에서도 같아요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          '반 전체 점검·채점 결과 불러오기는 다중 생성에서 쓸 수 있어요.',
          '명단은 선생님 본인만 볼 수 있어요. 지우기 전까지 그대로 남아 있어요.',
          '평가계획서는 학생 이름이 들어가지 않아 명단 없이 그대로 쓰면 돼요.',
          'AI가 쓴 문장은 꼭 한 번 읽어 보고 학생에 맞게 다듬어 주세요.',
        ],
      },
    ],
    links: [
      { label: '생기부 만들러 가기', path: '/create-saenggibu' },
      { label: '학급 관리 열기', path: '/classes' },
      { label: '내 스타일 설정하기', path: '/saenggibu-my-style' },
    ],
  },
  {
    id: 'update-2026-10-figures',
    date: '2026-10-16',
    title: '학습지에 그림이 바로 들어가요',
    summary: '그래프·지도·악보·삽화를 문제에 맞게 그려요. 말한 그림체와 올린 사진대로 그려요.',
    categories: ['quiz', 'chat'],
    popup: {
      tabLabel: '그림 넣기',
      slides: [
        { image: '/images/whats-new/update-2026-10-figures/slide-1.jpg', alt: '학습지에 그림이 들어가요. 그래프·지도·악보·삽화까지 문제에 맞게 바로 그려 넣어요.' },
        { image: '/images/whats-new/update-2026-10-figures/slide-2.jpg', alt: '악보·지도·그래프도 정확하게. 음 하나, 경계선 하나, 숫자 하나까지 그대로.' },
        { image: '/images/whats-new/update-2026-10-figures/slide-3.jpg', alt: 'AI 채팅에 말만 하세요. 그려 달라고 하면 PNG로 저장까지 돼요.' },
      ],
    },
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '학습지·시험지를 만들면 그림이 필요한 문항에 그림을 직접 그려 넣어요. 예전처럼 빈 상자로 남지 않아요.',
          '수학 도형·그래프, 과학 그래프, 악보·건반, 흐름도, 우리나라·시군구·세계 지도, 막대·꺾은선·원 그래프를 그려요.',
          '잎의 단면, 현미경, 실험 장치처럼 그리기 어려운 그림은 삽화로 넣어요.',
          '"컬러로 귀엽게", "색칠 도안으로", "교과서처럼 정밀하게"처럼 말하면 그 그림체로 그려요. 말하지 않으면 인쇄하기 좋은 흑백이에요.',
          '사진을 올리고 "사진 속 장치 그림을 넣어 줘"라고 하면, 사진을 보고 새로 그려 넣어요(PRO).',
          'AI 채팅에서도 악보·지도·자료 그래프를 그려 달라고 하면 정확하게 그리고 PNG로 저장할 수 있어요.',
        ],
      },
      {
        title: '1. 학습지를 만들면 그림까지 들어가요',
        description: '"잎의 단면 구조 그림에 A·B·C 표시를 넣고 이름을 묻는 문제로"처럼 그림이 들어갈 문항을 말해 주세요.',
        image: {
          src: '/images/help/update-2026-10-figures/ws-leaf.jpg',
          alt: '잎의 구조 학습지 1번 문항에 잎의 단면을 그린 흑백 삽화가 들어가 있고, 겉층·기둥 모양 조직·엉성한 조직에 A, B, C 표시가 붙은 화면',
          caption: '문항이 묻는 곳에 A·B·C 표시를 붙여 그려요',
        },
        items: [
          '정답이 그림에 드러나지 않게 그려요. 이름을 묻는 문제면 이름표 대신 기호만 붙여요.',
          '한글 파일·워드 파일로 받아도 그림이 그대로 들어가요.',
          '학생이 직접 그리는 칸(“회로를 그려 보세요”)은 비워 둬요.',
        ],
      },
      {
        title: '2. 원하는 그림체를 말해 주세요',
        description: '"초1이 좋아하게 그림은 알록달록 컬러로 귀엽게"처럼 그림체를 함께 적으면 그대로 그려요.',
        image: {
          src: '/images/help/update-2026-10-figures/ws-color.jpg',
          alt: '봄 동산 학습지 1번 문항에 개나리·진달래·민들레가 핀 컬러 삽화, 2번 문항에 나비와 벌이 날아다니는 귀여운 컬러 삽화가 들어간 화면',
          caption: '컬러로 그려 달라고 하면 학년에 맞는 귀여운 컬러 그림으로 그려요',
        },
        items: [
          '그림체를 말하지 않으면 흑백으로 그려요. 흑백 인쇄해도 또렷해요.',
          '조금 전에 말해 둔 그림체도 이어서 써요.',
          '다 만든 뒤에 "1번 그림을 컬러로 바꿔 줘"라고 하면 그 그림만 다시 그려요.',
        ],
      },
      {
        title: '3. 색칠 도안도 만들어요',
        description: '"나비와 꽃 색칠 도안을 크게 넣어 줘"처럼 말하면 아이들이 색칠할 수 있는 굵은 선 그림을 넣어요.',
        image: {
          src: '/images/help/update-2026-10-figures/ws-coloring.jpg',
          alt: '봄을 만나요 활동지의 봄의 정원 색칠하기 칸에 나비 세 마리와 튤립·꽃이 굵은 검은 선으로만 그려진 색칠 도안이 들어간 화면',
          caption: '안쪽을 비운 굵은 선으로 그려서 바로 색칠할 수 있어요',
        },
      },
      {
        title: '4. 올린 사진을 보고 그려요 (PRO)',
        description: '과학실 장치나 우리 반 화분 사진을 올리고 "사진 속 장치 그림을 넣고 A·B·C 표시해 줘"처럼 말해 보세요.',
        image: {
          src: '/images/help/update-2026-10-figures/ws-photo-ref.jpg',
          alt: '위에는 과학실 책상 위 스탠드·비커·삼발이·알코올램프 사진이 있고, 아래 학습지 1번 문항에는 같은 배치의 장치를 흑백 삽화로 그리고 A, B, C 표시를 붙인 화면',
          caption: '사진 속 장치 배치를 따라 학습지용 그림으로 새로 그려요',
        },
        items: [
          '사진을 그대로 붙이지 않고, 생김새와 배치만 따라 새로 그려요.',
          '사진 속 글자나 상표는 그리지 않아요.',
          '얼굴이 보이는 사진은 참고하지 않아요. 학생 얼굴이 그림에 들어가지 않게 하려는 거예요.',
          '사진을 여러 장 올리면 말한 사진을 골라 참고해요.',
        ],
      },
      {
        title: '5. 그래프는 숫자 그대로',
        description: '자료를 적으면 막대·꺾은선·원·띠그래프와 기후 그래프를 값 그대로 그려요.',
        image: {
          src: '/images/help/update-2026-10-figures/ws-climate.jpg',
          alt: '기후 학습지 1번 문항에 월별 강수량 막대와 기온 꺾은선이 함께 있는 서울 기후 그래프가 들어간 화면',
          caption: '강수량은 막대, 기온은 꺾은선으로 축을 따로 그려요',
        },
        items: [
          '그래프를 보고 값을 읽는 문제면 막대 위 숫자를 빼고 그려요.',
          '학생이 막대를 그려 넣는 빈 그래프 틀도 만들 수 있어요.',
        ],
      },
      {
        title: '6. AI 채팅에서 악보를 그려요',
        description: '"작은 별 첫 네 마디를 다장조 악보로 그리고 계이름을 달아줘"처럼 말해 보세요.',
        image: {
          src: '/images/help/update-2026-10-figures/chat-score.jpg',
          alt: '채팅에서 작은 별 첫 네 마디 악보를 그려 달라고 하자 오른쪽 미리보기에 4분의 4박자 오선 악보와 음표 아래 계이름 도 도 솔 솔이 보이는 화면',
          caption: '박자를 맞춰 그리고 계이름을 달아요. 「들어 보기」로 소리도 들을 수 있어요',
        },
        items: [
          '빈 오선보, 리듬 악보, 이름을 쓰는 피아노 건반도 그려요.',
          '저작권이 있는 최근 노래는 옮겨 적지 않고, 같은 박자의 연습용 가락을 새로 지어 드려요.',
        ],
      },
      {
        title: '7. 시군구 지도도 그려요',
        description: '"경기도 시군 지도에서 네 곳만 색칠하고 번호를 붙여줘"처럼 말하면 실제 경계로 그려요.',
        image: {
          src: '/images/help/update-2026-10-figures/chat-sgg-map.jpg',
          alt: '경기도 시군 지도에서 네 도시만 연한 색으로 칠하고 1부터 4까지 번호를 붙인 그림이 오른쪽 미리보기에 보이는 화면',
          caption: '시·군 경계는 통계청 자료 그대로예요',
        },
        items: [
          '우리나라 시도 지도, 백지도, 세계 지도(대륙·대양·나라)도 그려요.',
          '동네 약도나 읍·면·동 지도는 아직 그리지 못해요.',
        ],
      },
      {
        title: '8. 자료 그래프도 채팅에서',
        description: '숫자를 적고 그래프로 그려 달라고 하면 돼요.',
        image: {
          src: '/images/help/update-2026-10-figures/chat-climate.jpg',
          alt: '채팅에 서울의 월별 기온과 강수량을 적자 오른쪽 미리보기에 강수량 막대와 기온 꺾은선이 있는 기후 그래프가 보이는 화면',
          caption: '적은 숫자 그대로 그려요',
        },
      },
      {
        title: '9. 이미지 만들기에서도 알려 드려요',
        description: '이미지 만들기에 악보·지도·흐름도·자료 그래프를 적으면 입력창 위에 안내가 떠요.',
        image: {
          src: '/images/help/update-2026-10-figures/image-menu-hint.jpg',
          alt: '이미지 만들기 입력창에 바장조 음계를 그려 달라고 적자 위쪽에 악보·건반은 채팅에서 음 하나까지 정확하게 그려요라는 안내와 채팅에서 그리기 버튼이 보이는 화면',
          caption: '「채팅에서 그리기」를 누르면 적은 내용 그대로 채팅으로 옮겨요',
        },
      },
      {
        title: '알아 두세요',
        items: [
          'AI가 그린 그림이라 수업에 쓰기 전에 값과 표시를 한 번 확인해 주세요.',
          '삽화는 이미지 AI가 그려서 세밀한 구조가 교과서와 조금 다를 수 있어요.',
          'PDF·한글·워드·PPT 파일 안의 그림도 참고해요. 글자·표 캡처나 로고 같은 장식은 빼요.',
          '그림을 그리지 못한 문항은 빈 상자로 남아요. 그 자리에 직접 그림을 넣으면 돼요.',
        ],
      },
    ],
    links: [
      { label: '학습지 만들러 가기', path: '/chat?category=worksheet_gen' },
      { label: 'AI 채팅 열기', path: '/chat' },
    ],
  },
  {
    id: 'update-2026-10-mathfig',
    date: '2026-10-15',
    title: '수학 도형·그래프를 정확하게 그려요',
    summary: 'AI 채팅에서 그려 달라고 하면 길이·각도·좌표를 계산해서 그대로 그려요.',
    categories: ['chat'],
    popup: {
      tabLabel: '수학 그림',
      slides: [
        { image: '/images/whats-new/update-2026-10-mathfig/slide-1.jpg', alt: '수학 그림을 정확하게. 길이와 각도를 계산해서 그대로 그려요.' },
        { image: '/images/whats-new/update-2026-10-mathfig/slide-2.jpg', alt: '그래프도 숫자 그대로. 함수식과 실험값을 좌표에 정확히 찍어요.' },
        { image: '/images/whats-new/update-2026-10-mathfig/slide-3.jpg', alt: 'AI 채팅에서 바로. 그려 달라고 말하면 그림으로 저장까지 돼요.' },
      ],
    },
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          'AI 채팅에서 도형이나 그래프를 그려 달라고 하면, 길이·각도·좌표를 계산해서 정확한 그림으로 그려 줘요.',
          '함수 그래프와 실험 자료 그래프도 주어진 식과 숫자 그대로 좌표에 찍어요.',
          '그린 그림은 PNG나 SVG로 저장해서 학습지·시험지에 바로 넣을 수 있어요.',
          '이미지 만들기에 수학 그림을 적으면, 채팅에서 더 정확하게 그릴 수 있다고 알려 드려요.',
        ],
      },
      {
        title: '1. AI 채팅에서 그려 달라고 말해 보세요',
        description: '"AB=6, AC=8, ∠A=90°인 직각삼각형 ABC를 그려줘"처럼 조건을 적으면 돼요.',
        image: {
          src: '/images/help/update-2026-10-mathfig/chat-triangle.jpg',
          alt: '직각삼각형을 그려 달라고 하자 빗변 길이 10을 계산하고, 오른쪽 미리보기에 길이 6, 8, 10과 직각 표시가 있는 삼각형이 보이는 화면',
          caption: '빗변 길이를 계산하고 직각 표시까지 해서 그려요',
        },
        items: [
          '그림은 답변 오른쪽 미리보기에 바로 보여요.',
          '그림 아래 「PNG로 저장」 「SVG로 저장」 버튼으로 내려받아요.',
          '원·접선·수선·각의 이등분선 같은 작도, 겨냥도·전개도, 수직선도 그려요.',
          '"점 D를 추가해 줘"처럼 이어서 말하면 그림을 고쳐 그려요.',
        ],
      },
      {
        title: '2. 그래프도 식과 숫자 그대로',
        description: '함수식이나 표의 측정값을 적으면 좌표평면에 정확히 그려요.',
        image: {
          src: '/images/help/update-2026-10-mathfig/graph-function.jpg',
          alt: '이차함수 y=-x²+2x+3의 그래프에 꼭짓점 (1, 4), x절편 (-1, 0)과 (3, 0), y절편 (0, 3)이 표시된 그림',
          caption: '꼭짓점과 절편을 계산해서 표시해요',
        },
        items: [
          '꼭짓점·절편·교점은 계산한 자리에 점과 좌표를 달아요.',
          '실험 결과 표를 적으면 측정값을 그대로 점으로 찍고 이어요. 축 이름에 단위도 써요.',
          '속도-시간 그래프, 가열 곡선, 파동처럼 과학 그래프도 그려요.',
        ],
      },
      {
        title: '3. 실험 자료 그래프 예시',
        description: '"추의 무게가 10g, 20g, 30g, 40g일 때 용수철이 2cm, 4cm, 6cm, 8cm 늘어났어요. 그래프를 그려줘."',
        image: {
          src: '/images/help/update-2026-10-mathfig/graph-experiment.jpg',
          alt: '가로축은 추의 무게(g), 세로축은 늘어난 길이(cm)이고 네 측정값이 점으로 찍혀 직선으로 이어진 그래프',
          caption: '적은 숫자 그대로 점을 찍고 이어요',
        },
      },
      {
        title: '4. 이미지 만들기에서도 알려 드려요',
        description: '이미지 만들기에 수학 도형이나 그래프를 적으면 입력창 위에 안내가 떠요.',
        image: {
          src: '/images/help/update-2026-10-mathfig/image-menu-hint.jpg',
          alt: '이미지 만들기 입력창에 직각삼각형을 그려 달라고 적자, 위쪽에 수학 도형·그래프는 채팅에서 더 정확하게 그려요라는 안내와 채팅에서 그리기 버튼이 보이는 화면',
          caption: '「채팅에서 그리기」를 누르면 적은 내용 그대로 채팅으로 옮겨요',
        },
        items: [
          '옮긴 뒤 바로 보내지 않아요. 내용을 확인하고 보내 주세요.',
          '안내가 필요 없으면 X를 눌러 닫으면 돼요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          '회로도·렌즈·실험 장치 같은 과학 그림과 세포·지형 같은 삽화는 지금처럼 이미지로 만들어요.',
          'AI가 그린 그림이라 수업에 쓰기 전에 값과 표시를 한 번 확인해 주세요.',
          '조건이 모자라면 보기 좋은 값을 정해 그리고, 정한 값을 답변에 알려 드려요.',
        ],
      },
    ],
    links: [
      { label: 'AI 채팅 열기', path: '/chat' },
    ],
  },
  {
    id: 'update-2026-10-bigfile',
    date: '2026-10-12',
    title: '큰 파일도 끝까지 읽어요',
    summary: '긴 교재는 물어본 쪽을 찾아 읽고, 생기부는 학생 자료를 그대로 가져와요.',
    categories: ['saenggibu', 'chat'],
    popup: {
      tabLabel: '큰 파일',
      slides: [
        { image: '/images/whats-new/update-2026-10-bigfile/slide-1.jpg', alt: '큰 파일도 끝까지 읽어요. 300쪽 교재도 물어본 쪽을 찾아 읽어요.' },
        { image: '/images/whats-new/update-2026-10-bigfile/slide-2.jpg', alt: '학생 자료를 그대로 가져와요. 생기부 일괄 생성에 올린 파일에서 요약하지 않고 빠짐없이 나눠요.' },
        { image: '/images/whats-new/update-2026-10-bigfile/slide-3.jpg', alt: '스캔 파일도 150쪽까지. 긴 스캔 PDF도 끝까지 나눠 읽어요.' },
      ],
    },
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '생기부 일괄 생성에 올린 파일에서 학생별 자료를 줄이지 않고 원래 글 그대로 나눠 가져와요.',
          '생기부에 올린 스캔 PDF를 150쪽까지 읽어요. 예전에는 80쪽까지만 읽었어요.',
          '생기부 1명 작성에 큰 평가계획서와 학생 제출물을 함께 올려도, 뒤에 올린 제출물이 빠지지 않아요.',
          'AI 채팅에 올린 긴 교재는 물어본 쪽을 찾아서 읽고 답해요.',
        ],
      },
      {
        title: '1. 생기부 일괄 생성: 학생 자료를 그대로 가져와요',
        description: '학생 명단 엑셀이나 학생들의 제출물을 모은 파일을 올리면, 학생마다 자료를 나눠서 목록에 채워 줘요.',
        image: {
          src: '/images/help/update-2026-10-bigfile/batch-verbatim.jpg',
          alt: '관찰 기록 엑셀을 올린 뒤 6명 학생 정보를 찾았다는 제목 아래 학생마다 이름과 AI가 참고할 원문이 엑셀에 적은 그대로 보이는 화면',
          caption: '엑셀에 적은 관찰 내용이 줄지 않고 그대로 들어가요',
        },
        items: [
          '예전에는 이 과정에서 AI가 학생 자료를 짧게 줄여서, 원래 글의 일부만 남는 일이 많았어요.',
          '이제는 AI가 어느 줄이 어느 학생 것인지만 고르고, 내용은 올리신 파일의 글을 그대로 가져와요.',
          '실제 선생님 파일로 비교해 보니, 학생 자료에 남는 원래 글이 절반도 안 되던 것에서 거의 전부로 늘었어요.',
          '아주 긴 파일(50만 자까지)도 나눠 읽어서 뒤쪽 학생까지 빠짐없이 찾아요.',
          '학생이 세로줄(열)마다 놓인 엑셀도 학생별로 나눠 가져와요.',
          '파일 일부를 읽지 못했을 때는 학생 목록 위에 어느 쪽을 못 읽었는지 알려 드려요.',
        ],
      },
      {
        title: '2. 긴 스캔 PDF도 끝까지 읽어요',
        description: '종이를 스캔한 PDF처럼 글자를 바로 꺼낼 수 없는 파일은 AI가 쪽을 직접 읽어요.',
        items: [
          '이제 150쪽까지 10쪽씩 나눠 읽어서, 뒤쪽 학생 자료도 빠지지 않아요.',
          '실제 124쪽 스캔 파일로 확인해 보니, 예전에는 앞쪽 20명 정도만 찾던 것을 이제 30명 넘게 찾아요.',
        ],
      },
      {
        title: '3. 생기부 1명 작성: 학생 제출물이 빠지지 않아요',
        description: '교과세특(고등), 동아리, 진로에서 여러 파일을 함께 올릴 때 달라졌어요.',
        items: [
          '예전에는 첨부한 파일 글자를 모두 합쳐 20만 자까지만 읽어서, 학교 전체 평가계획서처럼 큰 파일을 먼저 올리면 뒤에 올린 학생 제출물이 통째로 빠질 수 있었어요.',
          '이제는 50만 자까지 읽어서 큰 평가계획서와 학생 제출물을 함께 올려도 제출물 내용을 바탕으로 써요.',
        ],
      },
      {
        title: '4. AI 채팅: 긴 교재는 물어본 쪽을 찾아 읽어요',
        description: '"212~214쪽으로 객관식 3문제 만들어 줘"처럼 쪽 번호를 말하면 그 쪽만 읽고 문제를 만들어요.',
        image: {
          src: '/images/help/update-2026-10-bigfile/chat-page-answer.jpg',
          alt: '240쪽 과학 교재를 올리고 212~214쪽으로 문제를 부탁하자 먹이 그물, 에너지 흐름, 생태계 평형 문제와 정답·해설이 나온 화면',
          caption: '240쪽 교재에서 212~214쪽 내용만으로 문제를 만들었어요',
        },
        items: [
          '단원 이름이나 주제로 말해도 목차를 보고 그 부분을 찾아요. 쪽 번호를 말하면 가장 정확해요.',
          '스캔 PDF는 앞 30쪽 뒤의 쪽도, 물어보면 그 쪽을 그 자리에서 읽어요.',
          '한글, 엑셀, PPT도 아주 긴 파일은 질문에 맞는 부분을 찾아 읽어요.',
          'PDF는 200MB, 한글·PPT는 100MB까지 올릴 수 있어요. 전에 올린 파일을 다시 올리면 바로 붙어요.',
          '채팅으로 학습지·PPT를 만들 때도 같은 방식으로 읽어요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          '생기부 일괄 생성에서 학생 한 명의 자료가 아주 길면 앞 1만 5천 자를 써요.',
          '스캔 PDF는 쪽이 많을수록 읽는 데 시간이 더 걸려요. 120쪽쯤이면 1분 안팎 걸려요.',
          '파일에서 가져온 학생 자료는 생성하기 전에 목록에서 한 번 확인해 주세요.',
        ],
      },
    ],
    links: [
      { label: '생기부 일괄 생성하러 가기', path: '/batch-saenggibu' },
      { label: 'AI 채팅 열기', path: '/chat' },
    ],
  },
  {
    id: 'update-2026-10-richanswer',
    date: '2026-10-12',
    title: 'AI 채팅 답을 사진과 함께 한눈에 봐요',
    summary: '여러 가지를 알려 줄 땐 사진 카드로 보여 주고, 조건은 눌러서 골라요.',
    categories: ['chat'],
    popup: {
      tabLabel: '사진 카드',
      slides: [
        { image: '/images/whats-new/update-2026-10-richanswer/slide-1.jpg', alt: '사진으로 한눈에 봐요. 장소·유물·악기처럼 여러 가지는 사진 카드로 나란히 보여 줘요.' },
        { image: '/images/whats-new/update-2026-10-richanswer/slide-2.jpg', alt: '조건만 눌러 고르면 돼요. 학년·장소·시간을 고르면 우리 반에 맞게 다시 추천해요.' },
        { image: '/images/whats-new/update-2026-10-richanswer/slide-3.jpg', alt: '긴 답도 술술 읽혀요. 핵심은 한눈에 보기로, 조심할 점은 주의로 따로 알려 줘요.' },
      ],
    },
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '체험학습 장소, 유물, 악기, 한살이 단계처럼 눈으로 보면 바로 알 수 있는 것을 여러 개 알려 줄 때 사진 카드로 나란히 보여 줘요.',
          '설명에 사진이 있으면 좋을 때는 답 중간에 사진 줄을 넣어 줘요.',
          '추천을 받은 뒤 학년, 장소 같은 조건을 눌러서 고르면 우리 반에 맞게 다시 추천해 줘요.',
          '긴 답은 맨 위 「한눈에 보기」로 핵심을 먼저 보여 주고, 조심할 점은 「주의」 상자로 따로 알려 줘요.',
          'AI가 답마다 사진이 도움이 될지 스스로 판단해요. 따로 설정할 것은 없어요.',
        ],
      },
      {
        title: '1. 여러 가지는 사진 카드로 나란히 봐요',
        description: '"서울 근교에서 초등 4학년 과학 체험학습 갈 만한 곳 5곳 추천해 줘"처럼 물어보세요.',
        image: {
          src: '/images/help/update-2026-10-richanswer/photo-cards.jpg',
          alt: '국립과천과학관, 서울시립과학관, 서울대공원, 국립생태원, 국립중앙과학관 사진이 위에 3개, 아래에 2개 카드로 놓이고 사진마다 이름과 한 줄 설명이 붙은 화면',
          caption: '사진 위에는 1순위, 단체 해설 같은 꼬리표와 사진을 가져온 사이트가 보여요',
        },
        items: [
          '사진을 누르면 크게 볼 수 있고, 아래 「출처」를 누르면 사진이 있던 사이트로 가요.',
          '휴대폰에서도 화면 폭에 맞춰 카드가 가지런히 놓여요.',
        ],
      },
      {
        title: '2. 설명 중간에 사진 줄이 들어가요',
        description: '"화산이 폭발하는 원리를 설명해 줘"처럼 한두 가지를 설명할 때는 관련 사진을 한 줄로 보여 줘요.',
        image: {
          src: '/images/help/update-2026-10-richanswer/photo-strip.jpg',
          alt: '화산 폭발 설명 중간에 용암이 뿜어져 나오는 사진 3장이 한 줄로 놓이고 마지막 사진에 +4가 적힌 화면',
          caption: '사진을 누르면 크게 보이고, 옆으로 넘기면 「+4」 나머지 사진도 볼 수 있어요',
        },
      },
      {
        title: '3. 조건은 눌러서 골라요',
        description: '"학급 단합 활동 추천해 줘"처럼 짧게 물어보면, 답 아래에 조건을 고르는 칸이 나와요.',
        image: {
          src: '/images/help/update-2026-10-richanswer/pick-form.jpg',
          alt: '학교급, 활동 장소, 소요 시간마다 고를 수 있는 버튼이 있고 초등 고학년, 체육관/운동장 포함, 2시간 연속 블록타임이 파랗게 골라진 화면',
          caption: '하나 이상 고르고 아래 파란 버튼을 누르세요',
        },
        items: [
          '항목마다 하나씩 고를 수 있어요. 다시 누르면 고른 것이 풀려요.',
          '모든 항목을 고르지 않아도 돼요. 고른 조건만 담아서 다시 물어봐요.',
          '처음부터 조건을 자세히 적어서 물어보면 보통은 이 칸이 나오지 않아요.',
        ],
      },
      {
        title: '4. 긴 답도 핵심부터 읽어요',
        description: '긴 설명은 맨 위 「한눈에 보기」에 핵심을 세 줄 안팎으로 먼저 정리해 줘요.',
        image: {
          src: '/images/help/update-2026-10-richanswer/summary-box.jpg',
          alt: '화산 폭발 설명 아래에 한눈에 보기 상자가 있고 핵심 세 가지가 점 목록으로 정리된 화면',
          caption: '바쁠 때는 「한눈에 보기」만 읽어도 돼요',
        },
        items: [
          '수업에서 조심할 점은 주황색 「주의」 상자, 알아 두면 좋은 점은 「팁」 상자로 따로 보여 줘요.',
          '"5~6학년"처럼 물결표를 쓴 글자에 줄이 그어지거나, 굵은 글씨 앞뒤로 별표(**)가 보이던 문제도 고쳤어요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          '사진 카드, 사진 줄, 조건 고르기는 로그인하면 쓸 수 있어요. 지난 대화를 다시 열어도 그대로 보여요.',
          '사진은 인터넷에서 찾아 보여 주는 것이라 실제와 조금 다를 수 있어요. 수업 자료에 쓰기 전에 출처 사이트에서 꼭 확인해 주세요.',
          '알맞은 사진을 찾지 못하면 사진 자리에 이름 첫 글자만 보여요.',
          '생기부 문장, 상담, 학부모 안내처럼 글을 쓰는 일에는 사진을 넣지 않아요. 표나 목록으로 달라고 하면 말한 모양대로 답해요.',
        ],
      },
    ],
    links: [
      { label: 'AI 채팅 열기', path: '/chat' },
    ],
  },
  {
    id: 'update-2026-10-voice',
    date: '2026-10-08',
    title: 'AI 채팅에 말로 묻고 귀로 들어요',
    summary: '마이크를 누르고 말하면 글자로 받아쓰고, 답은 나오는 대로 AI 목소리로 읽어 줘요.',
    categories: ['chat'],
    popup: {
      tabLabel: '말로 묻기',
      slides: [
        { image: '/images/whats-new/update-2026-10-voice/slide-1.jpg', alt: '이제 말로 물어봐요. 마이크를 누르고 말하면 글자로 바로 받아써요.' },
        { image: '/images/whats-new/update-2026-10-voice/slide-2.jpg', alt: '답을 바로 읽어 줘요. 답이 나오는 대로 AI 목소리로 들려줘요.' },
        { image: '/images/whats-new/update-2026-10-voice/slide-3.jpg', alt: '손이 바쁠 때 딱 좋아요. 요리하면서, 걸으면서 말로 묻고 귀로 들어요.' },
      ],
    },
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          'AI 채팅 입력창에 마이크 버튼이 생겼어요. 말하면 글자로 받아써서 입력창에 넣어 줘요.',
          '말로 물어보면 답이 화면에 나오는 대로 AI 목소리로 바로 읽어 줘요. 다 나올 때까지 기다리지 않아도 돼요.',
          '글로 물어본 답도 아래 「듣기」를 누르면 읽어 줘요.',
          '로그인하면 누구나 쓸 수 있어요. 따로 설정할 것은 없어요.',
        ],
      },
      {
        title: '1. 마이크를 누르고 말해요',
        description: '입력창 오른쪽 마이크를 누르고 "이번 주말에 가기 좋은 서울 근교 나들이 코스 세 곳 추천해 줘"처럼 말해 보세요.',
        image: {
          src: '/images/help/update-2026-10-voice/recording.jpg',
          alt: '입력창에 녹음 시간과 소리 크기에 따라 움직이는 막대가 보이고 오른쪽에 빨간 멈춤 버튼이 있는 화면',
          caption: '말하는 동안 막대가 움직이면 잘 듣고 있는 거예요',
        },
        items: [
          '처음 한 번은 브라우저가 마이크를 써도 되는지 물어요. 「허용」을 눌러 주세요.',
          '말을 다 했으면 빨간 버튼을 한 번 더 누르세요.',
        ],
      },
      {
        title: '2. 받아쓴 글을 보고 보내요',
        description: '받아쓴 글은 바로 보내지 않고 입력창에 넣어 둬요.',
        image: {
          src: '/images/help/update-2026-10-voice/transcribed.jpg',
          alt: '입력창에 "이번 주말에 가기 좋은 서울 근교 나들이 코스 세 곳 추천해줘."라는 받아쓴 글이 들어간 화면',
          caption: '틀린 글자가 있으면 고친 뒤 보내세요',
        },
        items: [
          '이미 써 둔 글이 있으면 그 뒤에 이어 붙여요.',
        ],
      },
      {
        title: '3. 답이 나오는 대로 읽어 줘요',
        description: '말로 물어본 답은 화면에 나오기 시작하면 바로 읽기 시작해요.',
        image: {
          src: '/images/help/update-2026-10-voice/reading.jpg',
          alt: '답이 나오는 중에 아래에 멈추기, 1x, AI 음성 버튼이 보이는 화면',
          caption: '「멈추기」로 언제든 멈출 수 있어요',
        },
        items: [
          '「1x」를 누르면 1.25배, 1.5배로 빨라져요.',
          '코드, 링크 주소, 이모지는 소리 내어 읽지 않고 건너뛰어요.',
        ],
      },
      {
        title: '4. 다른 답도 「듣기」로 들어요',
        description: '글로 물어본 답이나 지난 답도 아래 「듣기」를 누르면 읽어 줘요.',
        image: {
          src: '/images/help/update-2026-10-voice/listen.jpg',
          alt: '답 아래에 복사, 듣기, 공유 버튼이 있는 화면',
          caption: '답 아래 「듣기」를 누르세요',
        },
        items: [
          '요리하면서, 걸으면서처럼 화면을 보기 어려울 때 쓰기 좋아요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          '한 번에 최대 2분까지 말할 수 있어요. 2분이 되면 녹음이 저절로 끝나고 받아쓰기를 시작해요.',
          '말로 묻기는 하루 30분, AI 목소리로 읽기는 하루 60,000자까지 쓸 수 있어요.',
          'AI 목소리를 쓸 수 없을 때는 기기에 있는 목소리로 대신 읽어 줘요. 이때는 「기기 음성」으로 보여요.',
          '녹음한 목소리와 읽어 준 소리는 저장하지 않아요.',
          '시끄러운 곳에서는 잘못 받아쓸 수 있어요. 보내기 전에 꼭 한 번 확인해 주세요.',
        ],
      },
    ],
    links: [
      { label: 'AI 채팅 열기', path: '/chat' },
    ],
  },
  {
    id: 'update-2026-10-htmlpreview',
    date: '2026-10-03',
    title: 'AI가 만든 웹페이지를 바로 실행해 봐요',
    summary: 'AI가 만든 웹페이지·게임 코드를 오른쪽에서 바로 실행하고, 보면서 말로 고쳐요.',
    categories: ['chat'],
    popup: {
      tabLabel: '코드 미리보기',
      slides: [
        { image: '/images/whats-new/update-2026-10-htmlpreview/slide-1.jpg', alt: '만든 화면, 바로 실행. 웹페이지·게임 코드를 오른쪽에서 바로 봐요.' },
        { image: '/images/whats-new/update-2026-10-htmlpreview/slide-2.jpg', alt: '보면서 말로 고쳐요. 버튼 크게, 문제 10개로. 고친 화면이 바로 떠요.' },
        { image: '/images/whats-new/update-2026-10-htmlpreview/slide-3.jpg', alt: '복사도 파일도 쉽게. 코드 복사 버튼과 html 파일 받기.' },
      ],
    },
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          'AI 채팅에서 만든 웹페이지, 게임, 수업 활동 코드(HTML)를 화면 오른쪽에서 바로 실행해 볼 수 있어요. 복사해서 파일로 만들 필요가 없어요.',
          '코드 위에 「복사」와 「.html 받기」 버튼이 생겼어요.',
          '보면서 "버튼을 더 크게 해 줘"처럼 말하면 고친 화면이 새 버전으로 바로 떠요.',
          '어떤 모델로 답을 받아도 돼요. 따로 설정할 것은 없어요.',
        ],
      },
      {
        title: '1. 만들어 달라고 하면 오른쪽에 바로 떠요',
        description: '"영어 단어 맞히기 게임을 html로 만들어 줘"처럼 말해 보세요.',
        items: [
          '위쪽 「화면」과 「코드」를 눌러 실행 화면과 코드를 바꿔 볼 수 있어요.',
          '창을 닫으면 그 대화에서는 다시 저절로 열리지 않아요. 코드 위 「미리보기」를 누르면 다시 열려요.',
        ],
      },
      {
        title: '2. 보면서 말로 고쳐요',
        description: '"글씨를 더 크게 해 줘"처럼 바꾸고 싶은 점을 말하면 돼요.',
        items: [
          '위쪽 화살표로 이전 버전과 비교해 볼 수 있어요.',
          '처음부터 끝까지 다 들어 있는 코드여야 실행돼요. AI가 바뀐 부분만 보여 주면 "전체 코드로 다시 줘"라고 말해 주세요.',
        ],
      },
      {
        title: '3. 오류가 나면 버튼 하나로 고쳐요',
        description: '실행 중에 문제가 생기면 오른쪽 아래에 빨간 안내가 떠요.',
        items: [
          '입력창에 오류 내용이 담긴 부탁 문장이 채워져요. 보내면 AI가 원인을 찾아 고친 전체 코드를 다시 줘요.',
        ],
      },
      {
        title: '4. 복사, 파일 받기, 휴대폰에서도 돼요',
        items: [
          '「복사」를 누르면 코드가 그대로 복사돼요.',
          '「.html 받기」로 받은 파일은 크롬, 엣지, 웨일에서 열면 돼요. 학생에게 보낼 때도 이 파일을 보내 주세요.',
          '휴대폰에서는 저절로 열리지 않아요. 「미리보기」를 누르면 화면에 크게 열려요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          '웹페이지 코드(HTML)만 실행돼요. 파이썬, 구글 앱스 스크립트, 크롬 확장 프로그램은 여기서 실행해 볼 수 없어요.',
          '미리보기 안에 저장한 점수나 기록은 새로고침하면 사라져요. 카메라, 마이크, 내 컴퓨터 파일도 쓸 수 없어요.',
          '학생용 공유 링크는 아직 만들 수 없어요. 「.html 받기」로 받은 파일을 보내 주세요.',
          '미리보기 화면에는 비밀번호나 개인정보를 입력하지 마세요.',
          'AI가 만든 코드는 틀릴 수 있어요. 수업에 쓰기 전에 꼭 한 번 실행해 보세요.',
        ],
      },
    ],
    links: [
      { label: 'AI 채팅 열기', path: '/chat' },
    ],
  },
  {
    id: 'update-2026-10-gpt61',
    date: '2026-10-01',
    title: 'GPT-6.1로 더 꼼꼼하게 답해요',
    summary: 'GPT 칸이 GPT-6.1로 바뀌고, 한글 문서 채우기와 생기부 고급 모드도 더 정확해졌어요.',
    categories: ['chat', 'hwp', 'saenggibu'],
    popup: {
      tabLabel: 'GPT-6.1',
      slides: [
        { image: '/images/whats-new/update-2026-10-gpt61/slide-1.jpg', alt: 'GPT-6.1이 들어왔어요. GPT 칸이 GPT-6.1로. 더 꼼꼼하고 정확하게 답해요.' },
        { image: '/images/whats-new/update-2026-10-gpt61/slide-2.jpg', alt: '한글 문서도 더 정확하게. AI한글 양식 채우기. 제목과 표 모양을 지켜요.' },
        { image: '/images/whats-new/update-2026-10-gpt61/slide-3.jpg', alt: '생기부 고급 모드. 메모에 없는 내용은 덧붙이지 않아요.' },
      ],
    },
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          'AI 채팅의 GPT 칸이 GPT-6에서 GPT-6.1로 바뀌었어요.',
          '한글 파일을 만들거나 양식을 채울 때도 GPT-6.1이 써요. 제목과 표 모양을 더 잘 지켜요.',
          'AI 채팅에서 할 일을 생기부로 두고 고급 모드를 쓰면, 적어 주신 메모에 없는 활동이나 행동을 지어내 덧붙이지 않게 바뀌었어요.',
          '모두 PRO에서 쓸 수 있어요. 따로 설정할 것은 없어요.',
        ],
      },
      {
        title: '1. 채팅 위에서 GPT-6.1을 골라요',
        description: 'AI 채팅 화면 위쪽의 모델 이름을 누르면 GPT-6.1이 보여요.',
        image: {
          src: '/images/help/update-2026-10-gpt61/picker.jpg',
          alt: '모델 선택 목록에 빠른 모드, 고급 모드, GPT-6.1, Gemini 3.1 Pro, Gemini 3.8 Flash, Claude Sonnet 5.5가 보이는 화면',
          caption: '목록에서 GPT-6.1을 누르세요',
        },
        items: [
          '수업 설계, 문항 만들기, 표 정리처럼 여러 단계를 거치는 일에 잘 맞아요.',
          '전보다 더 자세히 답하느라 답이 조금 늦게 끝날 수 있어요.',
        ],
      },
      {
        title: '2. 수업 자료를 표로 정리해 받아요',
        description: '"중학교 2학년 과학 광합성 수업 도입 질문 3개와 예상 학생 답, 교사의 되묻기를 표로 만들어 줘"처럼 말해 보세요.',
        image: {
          src: '/images/help/update-2026-10-gpt61/gpt-answer.jpg',
          alt: 'GPT-6.1이 광합성 수업 도입 질문 3개와 예상되는 학생 답, 교사의 되묻기를 표로 정리하고 엑셀 파일까지 준비한 화면',
          caption: '질문, 예상 답, 되묻기를 표 한 장으로 정리해 줘요',
        },
        items: [
          '학년, 과목, 분량을 함께 적으면 더 알맞게 답해요.',
        ],
      },
      {
        title: '3. 한글 양식도 더 정확하게 채워요',
        description: '행정 업무에서 "가정통신문을 한글 파일로 만들어 줘"라고 하거나, 가진 양식을 올리고 채울 내용을 적어 주세요.',
        items: [
          '칸이 많은 신청서도 한 번에 채우고, 제목과 표 모양은 그대로 둬요.',
          '전화번호와 이메일은 개인정보 보호를 위해 AI에 보내지 않아요. AI가 한 번 물어볼 수 있고, 받은 파일에서 직접 넣어 주세요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          'AI가 쓴 날짜, 요일, 숫자는 틀릴 수 있어요. 보내기 전에 꼭 한 번 확인해 주세요.',
        ],
      },
    ],
    links: [
      { label: 'AI 채팅 열기', path: '/chat?category=pro_ai' },
    ],
  },
  {
    id: 'update-2026-09-models',
    date: '2026-09-30',
    title: 'GPT-6와 Claude Sonnet 5.5를 쓸 수 있어요',
    summary: 'AI 채팅에서 GPT-6와 Claude Sonnet 5.5를 골라 쓸 수 있어요. PRO에서 써 보세요.',
    categories: ['chat'],
    popup: {
      tabLabel: 'GPT-6·Claude 5.5',
      slides: [
        { image: '/images/whats-new/update-2026-09-models/slide-1.jpg', alt: 'GPT-6와 Claude Sonnet 5.5. 최신 AI가 들어왔어요. PRO에서 골라서 써요.' },
        { image: '/images/whats-new/update-2026-09-models/slide-2.jpg', alt: 'GPT-6, 어려운 질문도 정확하게. 수업 설계, 문항, 표 정리. GPT 칸이 GPT-6로 바뀌었어요.' },
        { image: '/images/whats-new/update-2026-09-models/slide-3.jpg', alt: 'Claude Sonnet 5.5, 글쓰기에 강해요. 가정통신문, 안내문 다듬기. Claude 칸에서 바로 써요.' },
      ],
    },
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          'AI 채팅의 GPT 칸이 GPT-5.6에서 GPT-6로 바뀌었어요.',
          'Claude 칸이 Claude Sonnet 5에서 Claude Sonnet 5.5로 바뀌었어요.',
          '두 모델 모두 PRO에서 쓸 수 있어요. 따로 설정할 것 없이 모델만 고르면 돼요.',
        ],
      },
      {
        title: '1. 채팅 위에서 모델을 골라요',
        description: 'AI 채팅 화면 위쪽의 모델 이름을 누르면 쓸 수 있는 모델이 모두 보여요.',
        image: {
          src: '/images/help/update-2026-09-models/picker.jpg',
          alt: '모델 선택 목록에 빠른 모드, 고급 모드, GPT-6, Gemini 3.1 Pro, Gemini 3.8 Flash, Claude Sonnet 5.5가 보이는 화면',
          caption: '목록에서 GPT-6나 Claude Sonnet 5.5를 누르세요',
        },
        items: [
          '무료 계정은 빠른 모드를 쓸 수 있고, Pro 표시가 붙은 모델은 PRO에서 쓸 수 있어요.',
          '고른 모델 이름은 화면 위쪽과 답변 위에 표시돼요.',
        ],
      },
      {
        title: '2. GPT-6로 수업 자료를 만들어요',
        description: '"중학교 2학년 과학 광합성 수업 도입 질문 3개와 예상 학생 답, 교사의 되묻기를 표로 만들어 줘"처럼 말해 보세요.',
        image: {
          src: '/images/help/update-2026-09-models/gpt-answer.jpg',
          alt: 'GPT-6가 광합성 수업 도입 질문 3개, 예상되는 학생 답, 교사의 되묻기를 표로 정리하고 도입 흐름과 판서 문장까지 제안한 화면',
          caption: '질문, 예상 답, 되묻기를 표 한 장으로 정리해 줘요',
        },
        items: [
          '수업 설계, 문항 만들기, 표 정리처럼 여러 단계를 거쳐야 하는 일에 써 보세요.',
          '학년, 과목, 분량을 함께 적으면 더 알맞게 답해요.',
        ],
      },
      {
        title: '3. Claude Sonnet 5.5로 글을 다듬어요',
        description: '딱딱한 안내문을 붙여 넣고 "학부모님이 읽기 편하고 따뜻한 말투로 다듬어 줘"처럼 말해 보세요.',
        image: {
          src: '/images/help/update-2026-09-models/claude-answer.jpg',
          alt: 'Claude Sonnet 5.5가 현장체험학습 안내 문장을 학부모님께 드리는 인사와 일시, 등교 시간, 준비물, 불참 시 연락 방법으로 다듬은 화면',
          caption: '핵심 안내는 그대로 두고 말투만 부드럽게 바꿔요',
        },
        items: [
          '가정통신문, 안내문, 생기부 문장처럼 글의 말투와 흐름이 중요한 일에 잘 맞아요.',
          '한글 파일이 필요하면 "한글 파일로 만들어 줘"라고 이어서 말하세요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          'AI가 쓴 날짜, 요일, 숫자는 틀릴 수 있어요. 보내기 전에 꼭 한 번 확인해 주세요.',
          '어느 모델이 더 잘 맞는지는 일마다 달라요. 같은 요청을 두 모델에 해 보고 마음에 드는 쪽을 쓰세요.',
        ],
      },
    ],
    links: [
      { label: 'AI 채팅 열기', path: '/chat?category=pro_ai' },
    ],
  },
  {
    id: 'update-2026-09-ppt-edit',
    date: '2026-09-29',
    title: 'PPT, 글자를 눌러 바로 고쳐요',
    summary: '만든 PPT에서 글자를 눌러 바로 고치고, 끌어서 순서를 바꿀 수 있어요. 고친 내용은 알아서 저장돼요.',
    categories: ['ppt'],
    popup: {
      tabLabel: 'PPT 바로 고치기',
      slides: [
        { image: '/images/whats-new/update-2026-09-ppt-edit/slide-1.jpg', alt: 'PPT, 글자를 눌러 바로 고쳐요. 편집 창 없이 그 자리에서 고치고, 고친 내용은 알아서 저장돼요.' },
        { image: '/images/whats-new/update-2026-09-ppt-edit/slide-2.jpg', alt: '채팅으로 말하면 그 장만 바꿔요. 바꿀 곳만 말하면 되고, 직접 고친 글자는 먼저 물어봐요.' },
        { image: '/images/whats-new/update-2026-09-ppt-edit/slide-3.jpg', alt: '끌어서 순서를 바꾸고 지우기도 쉬워요. 잘못 지우면 되돌리고, PPT·PDF로 바로 받아요.' },
      ],
    },
    sections: [
      {
        title: '1. 채팅에서 PPT를 만들어요',
        description: 'AI 채팅에서 PPT 만들기를 고르고 "중2 과학 광합성 수업 PPT 8장 만들어 줘"처럼 말해 보세요.',
        image: {
          src: '/images/help/update-2026-09-ppt-edit/deck.jpg',
          alt: '채팅 안에 열린 텍스트형 PPT. 위에 8장 저장됨, 가운데 슬라이드, 아래 작은 슬라이드 목록과 PPT 받기, PDF 받기 버튼이 보인다',
          caption: '다 만들어지면 채팅 안에 PPT가 바로 열려요',
        },
        items: [
          '아래 작은 그림을 누르면 그 장으로 넘어가요.',
          '제목 아래 "저장됨"이 보이면 지금 내용이 저장된 거예요.',
        ],
      },
      {
        title: '2. 글자를 눌러 바로 고쳐요',
        image: {
          src: '/images/help/update-2026-09-ppt-edit/editing.jpg',
          alt: '슬라이드 제목을 눌러 우리 반 광합성 탐구로 고치고 있는 화면',
          caption: '제목을 눌러 "우리 반 광합성 탐구"로 바꾸는 모습이에요',
        },
        items: [
          '고치고 싶은 글자를 누르면 그 자리에서 바로 쓸 수 있어요. 편집 화면을 따로 열지 않아도 돼요.',
          '고친 내용은 알아서 저장돼요.',
          '글자가 칸을 넘치면 알려 드려요. 조금 줄이거나 다시 디자인해 보세요.',
        ],
      },
      {
        title: '3. 채팅으로 말하면 그 장만 바꿔요',
        description: '채팅에 "2번 장 제목을 \'광합성에 필요한 세 가지\'로 바꿔 줘"처럼 말해 보세요.',
        image: {
          src: '/images/help/update-2026-09-ppt-edit/chat-syncing.jpg',
          alt: '채팅 내용을 반영하고 있어요 1/1장 안내와 함께 2번 슬라이드를 새로 디자인하고 있는 화면',
          caption: '말한 장만 새로 디자인해요. 한 장에 30초쯤 걸려요',
        },
        items: [
          '나머지 장은 그대로 둬요.',
          '직접 고친 글자가 있는 장이면 덮어쓰기 전에 먼저 물어봐요.',
        ],
      },
      {
        title: '말한 대로 바뀌었어요',
        image: {
          src: '/images/help/update-2026-09-ppt-edit/chat-synced.jpg',
          alt: '2번 슬라이드 제목이 광합성에 필요한 세 가지로 바뀐 화면',
          caption: '2번 장 제목이 말한 대로 바뀌었어요',
        },
      },
      {
        title: '4. 순서를 바꾸고, 필요 없는 장은 지워요',
        image: {
          src: '/images/help/update-2026-09-ppt-edit/delete-confirm.jpg',
          alt: '4번 슬라이드를 고른 뒤 지우기 버튼이 한 번 더 누르면 지워요로 바뀐 화면',
          caption: '지우기를 누르면 "한 번 더 누르면 지워요"로 바뀌어요',
        },
        items: [
          '아래 작은 그림을 끌어다 놓으면 순서가 바뀌어요.',
          '실수로 지우지 않게, 지우기는 두 번 눌러야 지워져요.',
        ],
      },
      {
        title: '잘못 지웠다면 되돌리기',
        image: {
          src: '/images/help/update-2026-09-ppt-edit/undo.jpg',
          alt: '4번 슬라이드를 지웠어요 안내와 되돌리기 버튼',
          caption: '화면 아래에 뜨는 되돌리기를 누르면 지운 장이 제자리로 돌아와요',
        },
      },
      {
        title: '다 만든 뒤에는',
        items: [
          'PPT 받기·PDF 받기로 파일을 받아 수업에 바로 쓰세요.',
          'PPT 파일에는 슬라이드가 그림으로 들어가요. 글자는 왓퀴즈에서 고친 뒤 받아 주세요.',
          '다시 디자인을 누르면 글자는 그대로 두고 그 장의 디자인만 새로 바꿔요.',
          '그림이 들어간 이미지형 PPT로도 만들 수 있어요. 지금 순서와 고친 글자 그대로 AI가 다시 그려요.',
          '만든 PPT는 라이브러리 내 자료에 저장돼요. 다시 열어 고치거나 발표 모드로 바로 띄울 수 있어요.',
        ],
      },
    ],
    links: [
      { label: 'PPT 만들러 가기', path: '/chat?category=ppt_maker' },
      { label: '라이브러리에서 보기', path: '/library' },
    ],
  },
  {
    id: 'update-2026-09-curriculum',
    date: '2026-09-29',
    title: '성취기준을 모두 담아 더 정확해요',
    summary: '교육과정 성취기준 원문을 모두 담았어요. 생기부·평가계획서·학습지·PPT가 실제 성취기준에 맞게 나와요.',
    categories: ['saenggibu', 'quiz', 'ppt'],
    popup: {
      tabLabel: '성취기준',
      slides: [
        { image: '/images/whats-new/update-2026-09-curriculum/slide-1.jpg', alt: '성취기준 원문을 모두 담았어요. 2022·2015 개정 교육과정, 초·중·고와 특성화고까지.' },
        { image: '/images/whats-new/update-2026-09-curriculum/slide-2.jpg', alt: '없는 성취기준은 지어내지 않아요. 원문을 먼저 찾아서 쓰니까 더 정확해요.' },
        { image: '/images/whats-new/update-2026-09-curriculum/slide-3.jpg', alt: '성취기준 찾기로 골라 넣어요. 생기부, 평가계획서, 학습지, PPT에서 쓸 수 있어요.' },
      ],
    },
    sections: [
      {
        title: '무엇이 다른가요',
        items: [
          '보통 AI에게 물어보면 성취기준을 기억에 기대어 쓰다 보니, 없는 코드나 문장을 그럴듯하게 지어낼 때가 있어요.',
          '왓퀴즈는 2022 개정(초·중·고)과 2015 개정(중·고) 교육과정의 성취기준 원문을 모두 담았어요. 특성화고 전문교과도 들어 있어요.',
          '학년과 과목을 알려 주시면 맞는 성취기준 원문을 먼저 찾아보고, 그 내용에 맞춰 써요.',
          '없는 성취기준 코드는 만들어 넣지 않아요.',
        ],
      },
      {
        title: '1. 성취기준을 찾아서 골라요',
        description: '생기부 쓰기에서 교과/세특을 고르고, 활동명(성취기준) 아래 성취기준 찾기를 눌러 보세요.',
        image: {
          src: '/images/help/update-2026-09-curriculum/picker.jpg',
          alt: '성취기준 찾기 창에서 중등을 고르고 광합성으로 찾아 두 개를 체크한 화면',
          caption: '중등에서 "광합성"으로 찾아 두 개를 고른 모습이에요',
        },
        items: [
          '초등·중등·고등을 고르고, "광합성"처럼 단원이나 낱말로 찾아요.',
          '쓰고 싶은 기준을 체크한 뒤 아래 "2개 넣기"를 누르면 돼요.',
          '학년에 따라 2015 개정을 적용받으면 알려 드려요. 버튼 하나로 2015 개정 기준도 볼 수 있어요.',
        ],
      },
      {
        title: '2. 원문 그대로 들어가요',
        image: {
          src: '/images/help/update-2026-09-curriculum/saenggibu-inserted.jpg',
          alt: '생기부 활동명 칸에 고른 성취기준 두 개가 코드와 원문 그대로 들어간 화면',
          caption: '고른 기준이 코드와 원문 그대로 들어갔어요',
        },
        items: [
          '글자 하나 바꾸지 않고 교육과정 원문 그대로 들어가요.',
          '이어서 학생 활동 메모를 넣고 만들면, 이 기준에 맞춘 문장을 써 드려요.',
        ],
      },
      {
        title: '3. 평가계획서 초안도 바로 만들어요',
        description: '평가계획서 만들기의 작년 평가계획서 칸에도 성취기준 찾기가 있어요.',
        image: {
          src: '/images/help/update-2026-09-curriculum/assessment-standards.jpg',
          alt: '평가계획서 화면에서 성취기준을 넣은 뒤 성취기준으로 평가계획서 초안 만들기 버튼이 보이는 화면',
          caption: '성취기준을 넣고 "성취기준으로 평가계획서 초안 만들기"를 눌러요',
        },
        items: [
          '작년 평가계획서가 없어도 괜찮아요. 올해 가르칠 성취기준만 넣으면 돼요.',
        ],
      },
      {
        title: '4. 이렇게 초안이 나와요',
        image: {
          src: '/images/help/update-2026-09-curriculum/assessment-draft.jpg',
          alt: '성취기준마다 평가명, 시기, 방법, 배점, 평가요소가 채워진 평가계획서 초안',
          caption: '성취기준마다 평가명·시기·방법·배점·평가요소가 채워져요',
        },
        items: [
          '넣은 성취기준 하나하나에 맞춰 평가요소를 짜서 입력 칸에 넣어 드려요.',
          '시기와 배점은 임시로 넣은 값이에요. 학교 계획에 맞게 고친 뒤 만들기를 누르면 평가계획서가 완성돼요.',
        ],
      },
      {
        title: '학습지·PPT에서도',
        items: [
          '채팅에서 "중2 과학 광합성 학습지 만들어 줘"처럼 학년과 과목을 말하면, 그 학년의 성취기준을 먼저 찾아 내용을 짜요.',
          '성취기준 코드를 적을 때도 실제로 있는 코드만 적어요.',
        ],
      },
    ],
    links: [
      { label: '생기부 쓰러 가기', path: '/create-saenggibu' },
      { label: '평가계획서 만들기', path: '/assessment-plan' },
      { label: '학습지 만들러 가기', path: '/chat?category=worksheet_gen' },
    ],
  },
  {
    id: 'update-2026-09-exam',
    date: '2026-09-21',
    title: '학교 시험지 모양으로, 한글 파일까지 바로 나와요',
    summary: '"시험지형 2단"이라고 말하면 제시문·<보기>까지 갖춘 시험지를 한글 파일로 바로 만들어요.',
    categories: ['quiz', 'hwp'],
    popup: {
      tabLabel: '시험지형',
      slides: [
        { image: '/images/whats-new/update-2026-09-exam/slide-1.jpg', alt: '학교 시험지 모양으로 만들어요. 2단 배치에 제시문, <보기>, 서술형 답란까지.' },
        { image: '/images/whats-new/update-2026-09-exam/slide-2.jpg', alt: '한글 파일이 바로 열려요. 오른쪽에서 고치고 한글 파일로 저장해요.' },
        { image: '/images/whats-new/update-2026-09-exam/slide-3.jpg', alt: '3번만 바꿔 달라고 하면 그 문항만. 한글 파일에도 바로 반영되고, 정답지도 함께 나와요.' },
      ],
    },
    sections: [
      {
        title: '1. 채팅에 "시험지형 2단"이라고 말해요',
        description: 'AI 채팅에서 학습지 생성을 고르고, 학년·과목·단원과 함께 "시험지형 2단으로"라고 적어 보세요.',
        image: {
          src: '/images/help/update-2026-09-exam/request.jpg',
          alt: '학습지 생성 채팅 입력 칸에 중학교 2학년 과학 물질의 구성 단원 시험지를 시험지형 2단으로 10문항 만들어 달라고 적은 화면',
          caption: '"제시문 하나에 두 문항을 묶고, <보기> 문항과 서술형도 넣어 줘"처럼 원하는 구성을 함께 적어도 돼요',
        },
        items: [
          '제시문을 읽고 푸는 묶음 문항, <보기>에서 고르는 문항, 서술형 답란도 말하면 넣어 드려요.',
          '2단 시험지는 6문항 이상일 때 만들어져요. 문항이 적으면 1단으로 만들고 알려 드려요.',
          '무료 계정은 한 번에 10문항, PRO는 40문항까지 만들 수 있어요.',
        ],
      },
      {
        title: '2. 한글 파일이 오른쪽에 바로 열려요',
        image: {
          src: '/images/help/update-2026-09-exam/hwpx-panel.jpg',
          alt: '왼쪽에는 제시문과 1번 문항, 정답과 해설이 보이는 초안 카드가 있고, 오른쪽에는 2단으로 배치된 한글 시험지가 열린 화면',
          caption: '왼쪽은 문항 초안, 오른쪽은 만들어진 한글 파일이에요',
        },
        items: [
          '따로 만들기 버튼을 누르지 않아도 문항이 정리되면 한글 파일이 만들어져 오른쪽에 열려요.',
          '오른쪽 편집기에서 글자를 바로 고치고, 한글 파일로 저장을 누르면 내 컴퓨터에 받아져요.',
          '왼쪽 초안 카드를 펼치면 문항마다 정답과 해설을 확인할 수 있어요.',
        ],
      },
      {
        title: '3. "3번만 바꿔 줘"라고 하면 그 문항만 바뀌어요',
        description: '채팅에 "3번 문항을 조금 더 쉬운 문제로 바꿔 줘"처럼 말해 보세요.',
        image: {
          src: '/images/help/update-2026-09-exam/chat-edit.jpg',
          alt: '이렇게 바꿨어요 안내에 문항 3 내용, 해설, 선택지 변경이 보이고, 아래에 한글 문서에 반영했어요 알림이 뜬 화면',
          caption: '무엇이 바뀌었는지 알려 주고, 한글 파일에도 바로 반영돼요',
        },
        items: [
          '말한 문항만 바꾸고 나머지 문항과 2단 배치는 그대로 둬요.',
          '마음에 들지 않으면 안내 오른쪽의 되돌리기를 눌러 이전 초안으로 돌아가요.',
          '오른쪽 한글 파일을 직접 고친 뒤 채팅으로 수정하면, 직접 고친 내용을 먼저 내려받을지 물어봐요.',
        ],
      },
      {
        title: '4. 정답지도 함께 만들어져요',
        description: '만든 시험지는 라이브러리 내 자료에 저장돼요. 시험지를 열고 정답지를 누르면 정답과 해설만 모아 볼 수 있어요.',
        image: {
          src: '/images/help/update-2026-09-exam/answer-key.jpg',
          alt: '라이브러리에서 시험지를 열고 정답지 탭을 누르자 정답 및 해설 4쪽이 보이는 화면',
          caption: '정답과 해설이 따로 정리된 정답지예요',
        },
        items: [
          '한글이나 PDF로 받으면 학생용 시험지 뒤에 정답지가 이어져 있어요. 학생에게 나눠 줄 때는 앞쪽만 인쇄하세요.',
          'PDF나 워드 파일로도 받을 수 있어요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          '오른쪽 편집기에서는 2단 배치가 조금 다르게 보이거나 일부 문항이 다음 쪽으로 밀려 보일 수 있어요. 저장한 한글 파일은 한글 프로그램에서 2단으로 정상 열려요.',
          'AI가 만든 문항과 정답은 시험에 쓰기 전에 꼭 한 번 확인해 주세요.',
        ],
      },
    ],
    links: [
      { label: '시험지 만들러 가기', path: '/chat?category=worksheet_gen' },
      { label: '라이브러리에서 보기', path: '/library' },
    ],
  },
  {
    id: 'update-2026-09-saenggibu',
    date: '2026-09-20',
    title: '내 문체 그대로, 한 번에 150명까지 생기부를 써요',
    summary: '잘 쓴 예시를 등록하면 그 문체로 쓰고, 학급 파일 하나로 150명까지 한 번에 만들어요.',
    categories: ['saenggibu'],
    popup: {
      tabLabel: '생기부 150명',
      slides: [
        { image: '/images/whats-new/update-2026-09-saenggibu/slide-1.jpg', alt: '내 문체 그대로 생기부를. 잘 쓴 예시를 한 번 등록하면 매번 그 스타일로 써요.' },
        { image: '/images/whats-new/update-2026-09-saenggibu/slide-2.jpg', alt: '한 번에 150명까지. 학급 파일 하나 올리면 학생마다 따로 써 드려요.' },
        { image: '/images/whats-new/update-2026-09-saenggibu/slide-3.jpg', alt: '다음 학급도 그대로. 설정은 그대로 두고 다음 반 파일만 올려요.' },
      ],
    },
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '내 스타일에 잘 쓴 예시를 한 번 등록해 두면, 매번 말하지 않아도 그 문체와 형식으로 생기부를 써요.',
          '다중 생성은 한 번에 150명까지 만들 수 있어요. 몇 명이 끝났는지도 바로 보여요.',
          '한 학급이 끝나면 같은 설정으로 다음 학급을 바로 이어서 만들 수 있어요.',
        ],
      },
      {
        title: '1. 내 스타일에 잘 쓴 예시를 붙여 넣어요',
        description: 'AI 생기부 생성 아래 내 스타일에서 행동발달, 교과세특처럼 종류를 고르고, 잘 썼다고 생각하는 생기부 예시를 붙여 넣으세요.',
        image: {
          src: '/images/help/update-2026-09-saenggibu/style-filled.jpg',
          alt: '행동발달 스타일 창에 예시 두 개를 붙여 넣고 AI 분석을 누르자 문체, 고정 문구·형식, 서술 흐름 칸이 자동으로 채워진 화면',
          caption: 'AI 분석을 누르면 문체와 서술 흐름을 알아서 정리해 줘요',
        },
        items: [
          '예시가 여러 개면 빈 줄 두 번으로 나눠 붙여 넣어요. PDF, 한글, 이미지 파일로 올려도 돼요.',
          '예시에 학생 이름이 있으면 지우고 붙여 넣어 주세요.',
          '채워진 칸은 직접 고칠 수 있어요. 마음에 들면 이대로 저장하기를 눌러요.',
        ],
      },
      {
        title: '저장하면 적용 중으로 바뀌어요',
        image: {
          src: '/images/help/update-2026-09-saenggibu/style-saved.jpg',
          alt: '내 스타일 화면에서 행동발달 카드에 예시 1개와 적용 중 스위치가 켜져 있는 화면',
          caption: '종류마다 따로 설정하고, 스위치로 잠시 끌 수도 있어요',
        },
        items: [
          '공통 설정에는 학교나 교육청 기재 지침을 넣어 두면 모든 종류에 함께 적용돼요.',
          '생기부 작성 화면 오른쪽 위에 ✓ 내 스타일 적용 중이 보이면 반영되고 있는 거예요.',
        ],
      },
      {
        title: '2. 다중 생성에 학급 파일을 올려요',
        description: '생기부 작성에서 다중 생성을 누르고, 종류를 고른 뒤 학생별 기록 파일을 올리세요.',
        image: {
          src: '/images/help/update-2026-09-saenggibu/batch-ready.jpg',
          alt: '다중 생성 화면에서 행동발달을 고르고 1학년3반 관찰기록 엑셀 파일을 올리자 8명 학생 정보를 찾았어요와 8명 생기부 문구 만들기 버튼이 나온 화면',
          caption: '학생 이름과 기록을 찾아서 한눈에 보여 줘요',
        },
        items: [
          '양식을 맞출 필요 없어요. 누가기록, 상담 메모, 행동 관찰표를 그대로 올리면 돼요.',
          '엑셀, PDF, PPT, 한글, 이미지 파일을 올릴 수 있어요.',
          '인식한 이름이나 기록이 틀리면 그 자리에서 고치거나 제외할 수 있어요.',
        ],
      },
      {
        title: '3. 몇 명이 끝났는지 보면서 기다려요',
        image: {
          src: '/images/help/update-2026-09-saenggibu/batch-progress.jpg',
          alt: '생기부를 작성하고 있어요 화면에 0/8명 완료와 8명 중 8명을 동시에 작성하고 있어요 안내, 생성 중단 버튼이 보이는 화면',
          caption: '여러 명을 동시에 써서 기다리는 시간이 짧아졌어요',
        },
        items: [
          '한 번에 150명까지 만들 수 있어요.',
          '중간에 멈추고 싶으면 생성 중단을 누르세요.',
        ],
      },
      {
        title: '4. 학생마다 결과를 확인해요',
        image: {
          src: '/images/help/update-2026-09-saenggibu/batch-results.jpg',
          alt: '8명 생기부 완성 화면에 기록에 저장했어요, 엑셀 다운로드, 학생별 행동발달 바이트 수가 나온 목록',
          caption: '결과는 내 생기부 기록에 자동으로 저장돼요',
        },
        items: [
          '엑셀 다운로드로 모든 학생의 문구를 한 파일로 받아 나이스에 옮길 수 있어요.',
        ],
      },
      {
        title: '학생 이름을 누르면 문구가 펼쳐져요',
        image: {
          src: '/images/help/update-2026-09-saenggibu/batch-detail.jpg',
          alt: '김하늘 학생 줄을 펼치자 행동발달 문구 전문과 AI로 다듬기 버튼이 보이는 화면',
          caption: '올린 기록을 바탕으로 학생마다 다르게 써 드려요',
        },
        items: [
          '고치고 싶은 학생은 AI로 다듬기를 눌러 그 학생만 다시 쓸 수 있어요.',
          '목록 아래에서 "더 담백하게"처럼 원하는 방향을 골라 전체를 다시 요청할 수도 있어요.',
        ],
      },
      {
        title: '5. 다음 학급 만들기를 눌러요',
        image: {
          src: '/images/help/update-2026-09-saenggibu/batch-next.jpg',
          alt: '결과 목록 아래 입력으로 돌아가기와 다음 학급 만들기 버튼, 행동발달 1500B 설정을 그대로 이어서 만들어요 안내가 보이는 화면',
          caption: '종류와 분량 설정을 그대로 가져가요',
        },
        items: [
          '처음부터 다시 설정하고 싶으면 설정도 초기화하고 새로 시작을 누르세요.',
        ],
      },
      {
        title: '다음 반 파일만 올리면 돼요',
        image: {
          src: '/images/help/update-2026-09-saenggibu/batch-continue.jpg',
          alt: '다중 생성 첫 화면 위쪽에 이전 설정으로 이어서 만들어요 행동발달 1500B 안내가 뜨고 파일 올리기 칸이 비어 있는 화면',
          caption: '위쪽 안내로 어떤 설정이 이어졌는지 확인해요',
        },
        items: [
          '담임 반과 교과 수업 반이 여러 개여도 반마다 같은 설정으로 빠르게 만들 수 있어요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          '내 스타일 분석은 무료 계정에서 1회 체험할 수 있어요. 저장하고 생성에 적용하는 건 PRO에서 쓸 수 있어요.',
          '다중 생성은 PRO에서 쓸 수 있어요.',
          'AI가 쓴 문구는 나이스에 옮기기 전에 꼭 한 번 읽어 주세요.',
        ],
      },
    ],
    links: [
      { label: '내 스타일 설정하기', path: '/saenggibu-my-style' },
      { label: '생기부 쓰러 가기', path: '/create-saenggibu' },
    ],
  },
  {
    id: 'update-2026-09-scoring',
    date: '2026-09-16',
    title: '채점 근거를 답안 위에 형광펜으로 보여 드려요',
    summary: '답안 사진·PDF 위에 AI가 본 문장을 형광펜으로 칠해 드려요. 채점 결과는 생기부로 바로 이어져요.',
    categories: ['scoring', 'saenggibu'],
    popup: {
      tabLabel: '채점 형광펜',
      slides: [
        { image: '/images/whats-new/update-2026-09-scoring/slide-1.jpg', alt: '채점 근거를 답안 위에 형광펜으로. AI가 어느 문장을 보고 점수를 줬는지 바로 보여요.' },
        { image: '/images/whats-new/update-2026-09-scoring/slide-2.jpg', alt: '충족은 초록, 일부는 주황. 기준마다 학생 답안 어디가 맞았는지 한눈에 확인해요.' },
        { image: '/images/whats-new/update-2026-09-scoring/slide-3.jpg', alt: '채점 결과로 생기부까지. 생기부로 이어가기를 누르면 채점한 내용으로 바로 써요.' },
      ],
    },
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '점수만 보고는 AI가 답안의 어느 부분을 보고 그렇게 판단했는지 알기 어려웠어요.',
          '이제 학생이 쓴 답안 사진이나 PDF 위에, AI가 근거로 삼은 문장을 형광펜처럼 칠해 드려요.',
          '확인이 끝난 채점 결과는 버튼 하나로 생기부 쓰기로 넘어가요.',
        ],
      },
      {
        title: '1. 채점 기준표와 답안 파일을 넣어요',
        description: 'AI 서술형 채점에서 채점 기준표를 붙여넣고, 1명 채점을 고른 뒤 파일 첨부로 학생 답안을 올려요.',
        image: {
          src: '/images/help/update-2026-09-scoring/input.jpg',
          alt: '서술형 채점 화면에서 학생 과제 칸 아래에 답안 사진 파일이 첨부되고, 채점 설정과 채점 시작 버튼이 보이는 화면',
          caption: '답안을 찍은 사진 한 장을 올린 모습이에요',
        },
        items: [
          '손글씨 답안을 휴대폰으로 찍은 사진이나 스캔한 PDF를 그대로 올리면 돼요.',
          '학생 수준과 채점 엄격도를 고른 뒤 채점 시작을 눌러요.',
          '파일을 올려 채점하는 기능은 PRO에서 쓸 수 있어요.',
        ],
      },
      {
        title: '2. 점수와 항목별 근거가 나와요',
        image: {
          src: '/images/help/update-2026-09-scoring/result.jpg',
          alt: '채점 결과 18점과 함께 문제 원인 분석 7/8점 등 항목별 점수, 평가 기준과 평가 근거가 나온 화면',
          caption: '기준 항목마다 점수와 이유가 나와요',
        },
        items: [
          '항목마다 평가 기준과 AI가 그렇게 판단한 근거가 함께 나와요.',
          '점수나 문장이 마음에 들지 않으면 그 자리에서 수정하거나 AI에게 다시 요청할 수 있어요.',
        ],
      },
      {
        title: '3. 근거 보기를 누르면 답안 위에 형광펜이 칠해져요',
        description: '결과 위쪽 학생 카드의 근거 보기를 눌러 보세요.',
        image: {
          src: '/images/help/update-2026-09-scoring/highlight.jpg',
          alt: '학생 손글씨 답안 위에 근거 문장이 초록색과 주황색으로 칠해지고, 오른쪽에 항목별 근거와 기준 조건별 확인이 보이는 검토 화면',
          caption: '왼쪽은 학생 답안, 오른쪽은 항목별 근거예요',
        },
        items: [
          '초록색(✓)은 기준을 충족한 문장, 주황색(△)은 일부만 충족한 문장이에요. 부족한 부분은 빨간색(✕)으로 표시돼요.',
          '답안 왼쪽의 번호 표시는 오른쪽 근거 설명의 번호와 같아요.',
          '형광펜은 채점이 끝나고 잠시 뒤에 나타나요. 조금만 기다려 주세요.',
        ],
      },
      {
        title: '근거를 누르면 답안의 그 문장으로 이어져요',
        image: {
          src: '/images/help/update-2026-09-scoring/highlight-linked.jpg',
          alt: '오른쪽 근거 하나를 누르자 학생 답안의 해당 문장에 파란 테두리가 생긴 화면',
          caption: '오른쪽 근거를 누르면 답안의 해당 문장에 파란 테두리가 생겨요',
        },
        items: [
          'AI의 판단이 맞는지 답안과 나란히 놓고 바로 확인할 수 있어요.',
          '여러 명을 채점했을 때도 학생마다 근거 보기로 똑같이 확인해요.',
        ],
      },
      {
        title: '4. 생기부로 이어가요',
        description: '결과 맨 아래에서 생기부로 이어가기를 누르세요.',
        image: {
          src: '/images/help/update-2026-09-scoring/handoff-button.jpg',
          alt: '채점 결과 아래 답안·결과 엑셀, 복사하기, 생기부로 이어가기, 채점 기록 버튼과 학생용·교사용 PDF 버튼이 보이는 화면',
          caption: '생기부로 이어가기 옆에서 엑셀과 PDF도 받을 수 있어요',
        },
        items: [
          '답안·결과 엑셀에는 AI가 읽은 답안과 점수가 함께 들어가요.',
          '학생용 PDF는 생기부 문구를 빼고 만들어서 학생에게 바로 나눠 줄 수 있어요.',
        ],
      },
      {
        title: '채점한 내용이 생기부 자료로 들어가요',
        image: {
          src: '/images/help/update-2026-09-scoring/handoff-saenggibu.jpg',
          alt: '생기부 작성 화면에 채점 결과 자료가 들어가 1명 학생 정보를 찾았어요 안내와 1명 생기부 문구 만들기 버튼이 보이는 화면',
          caption: '채점 결과가 생기부 자료로 들어가 있어요',
        },
        items: [
          '학생 답안과 채점 결과를 참고해서 교과세특 문구를 써 드려요.',
          '학생 이름을 확인하고 1명 생기부 문구 만들기를 누르면 돼요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          '형광펜은 사진(JPG·PNG 등)과 PDF 답안에서 보여요. 글로 붙여넣은 답안이나 한글 파일은 점수와 근거만 나와요.',
          '글씨가 너무 흐리거나 기울어진 사진은 형광펜 위치가 조금 어긋날 수 있어요. 밝은 곳에서 반듯하게 찍어 주세요.',
        ],
      },
    ],
    links: [
      { label: '서술형 채점하러 가기', path: '/scoring' },
      { label: '생기부 쓰러 가기', path: '/create-saenggibu' },
    ],
  },
  {
    id: 'update-2026-09-ingest',
    date: '2026-09-16',
    title: '링크·유튜브·녹음 파일을 AI가 직접 읽어요',
    summary: '기사 링크, 유튜브 영상, 회의 녹음을 채팅에 넣으면 AI가 읽고 들어서 수업 자료와 회의록으로 정리해요.',
    categories: ['chat'],
    popup: {
      tabLabel: '링크·녹음',
      slides: [
        { image: '/images/whats-new/update-2026-09-ingest/slide-1.jpg', alt: '링크만 붙여 넣으세요. 기사, 블로그, 공지 글을 AI가 직접 읽어요.' },
        { image: '/images/whats-new/update-2026-09-ingest/slide-2.jpg', alt: '유튜브 영상도 읽어요. 영상을 보고 들어서 요약과 학습지로 만들어요.' },
        { image: '/images/whats-new/update-2026-09-ingest/slide-3.jpg', alt: '회의 녹음이 회의록으로. 녹음 파일을 올리면 받아쓰고 한글 파일로 정리해요.' },
      ],
    },
    sections: [
      {
        title: '무엇이 달라졌나요',
        items: [
          '예전에는 링크를 붙여 넣어도 AI가 글을 열어 보지 못해서, 본문을 복사해 붙여야 했어요.',
          '이제 채팅에 링크, 유튜브 주소, 녹음 파일을 넣으면 AI가 직접 읽고 들어서 그 내용으로 답해요.',
          '로그인만 하면 무료 계정에서도 쓸 수 있어요.',
        ],
      },
      {
        title: '1. 하고 싶은 일과 링크를 함께 적어요',
        image: {
          src: '/images/help/update-2026-09-ingest/link-request.jpg',
          alt: '자유 대화 입력 칸에 이 글을 읽고 중학교 2학년 과학 수업용으로 핵심 내용 5줄 요약과 확인 문제 3개를 만들어 달라는 요청과 위키백과 광합성 주소를 적은 화면',
          caption: '요청 문장 뒤에 링크를 붙여 넣으면 돼요',
        },
        items: [
          '뉴스 기사, 블로그, 학교 공지, 공개된 PDF 링크를 읽을 수 있어요.',
          '한 번에 링크 10개까지 넣을 수 있어요.',
          '로그인이 필요한 페이지나 비공개 글은 읽지 못해요. 이때는 본문을 복사해 붙여 주세요.',
        ],
      },
      {
        title: '2. 글을 읽고 바로 수업 자료로 만들어요',
        image: {
          src: '/images/help/update-2026-09-ingest/link-result.jpg',
          alt: '왼쪽에 광합성 핵심 내용 5줄 요약과 확인 문제 3개가 나오고, 오른쪽에 광합성의 이해 학습지 한글 문서가 열린 화면',
          caption: '읽은 링크는 입력 칸 위에 참고 파일로 붙어 있어요',
        },
        items: [
          '읽은 링크는 입력 칸 위에 참고 중으로 표시돼요. 이어서 질문해도 같은 글을 참고해요.',
          '학습지나 문제를 부탁하면 한글 파일까지 만들어 오른쪽에 열어 드려요.',
        ],
      },
      {
        title: '유튜브 영상도 같은 방법으로 읽어요',
        items: [
          '유튜브 주소를 붙여 넣으면 AI가 영상을 보고 들어서 내용을 정리해요.',
          '영상 길이에 따라 1~3분 정도 걸리고, 긴 영상은 앞 120분까지 읽어요.',
          '수업에 쓸 영상을 요약하거나, 영상 내용으로 확인 문제를 만들 때 써 보세요.',
        ],
      },
      {
        title: '3. 녹음 파일을 올리면 받아써요',
        description: '입력 칸의 클립 버튼으로 회의나 수업 녹음 파일을 올리세요.',
        image: {
          src: '/images/help/update-2026-09-ingest/audio-upload.jpg',
          alt: '입력 칸 위에 3학년 협의회 녹음 파일이 올라가고 음성을 듣고 받아쓰고 있어요 1~3분 안내가 보이는 화면',
          caption: '받아쓰는 동안 잠시 기다려 주세요',
        },
        items: [
          'mp3, m4a, wav, mp4 파일을 올릴 수 있어요. 휴대폰 녹음 파일도 그대로 올리면 돼요.',
          '음성·영상 파일은 50MB까지 올릴 수 있어요.',
          '안 들리는 부분은 지어내지 않고 (불명확)으로 표시해요.',
        ],
      },
      {
        title: '4. 회의록으로 정리해 달라고 해요',
        image: {
          src: '/images/help/update-2026-09-ingest/audio-result.jpg',
          alt: '녹음을 학년 협의회 회의록으로 정리해 달라는 요청에 회의 개요 표가 나오고, 오른쪽에 3학년 학년 협의회 회의록 한글 문서가 열린 화면',
          caption: '회의록 한글 파일까지 바로 만들어져요',
        },
        items: [
          '"안건별 결정 사항과 할 일을 표로"처럼 원하는 모양을 말하면 그대로 정리해요.',
          '오른쪽 한글 편집기에서 고치고 한글 파일로 저장을 누르면 돼요.',
        ],
      },
      {
        title: '결정 사항과 할 일이 표로 정리돼요',
        image: {
          src: '/images/help/update-2026-09-ingest/audio-table.jpg',
          alt: '안건별 결정 사항과 후속 조치 표에 현장체험학습 버스 4대 확정, 채점 기준표 공유, 담당과 기한이 정리된 화면',
          caption: '녹음에서 나온 담당과 기한까지 표에 들어가요',
        },
        items: [
          '녹음에 나오지 않은 날짜나 장소는 [확인 필요]로 비워 둬요. 직접 채워 주세요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          'AI가 읽은 링크나 받아쓴 내용은 틀릴 수 있어요. 중요한 숫자와 이름은 꼭 한 번 확인해 주세요.',
          '다른 사람의 목소리가 담긴 녹음은 동의를 받은 뒤 올려 주세요.',
        ],
      },
    ],
    links: [
      { label: 'AI 채팅 열기', path: '/chat?category=pro_ai' },
    ],
  },
  {
    id: 'update-2026-09-hwp-doc',
    date: '2026-08-22',
    title: '가정통신문·평가계획서가 한글 파일로 바로 나와요',
    summary: '가정통신문은 공문 모양 한글 파일로, 평가계획서는 학교 양식 한글 파일로 바로 받아요.',
    categories: ['hwp'],
    popup: {
      tabLabel: '한글 문서',
      slides: [
        { image: '/images/whats-new/update-2026-09-hwp-doc/slide-1.jpg', alt: '가정통신문을 한글 파일로. 날짜, 장소, 준비물만 말하면 공문 모양으로 만들어요.' },
        { image: '/images/whats-new/update-2026-09-hwp-doc/slide-2.jpg', alt: '화면에서 바로 고쳐요. 오른쪽 한글 편집기에서 고치고 한글 파일로 저장해요.' },
        { image: '/images/whats-new/update-2026-09-hwp-doc/slide-3.jpg', alt: '평가계획서도 한글 파일로. 성취기준만 고르면 학교 양식 한글 문서가 나와요.' },
      ],
    },
    sections: [
      {
        title: '1. 행정 업무 채팅에 필요한 내용만 적어요',
        description: 'AI 채팅에서 할 일을 행정 업무로 고르고, 어떤 문서를 누구에게 보낼지와 날짜·장소·준비물을 적어 보세요.',
        image: {
          src: '/images/help/update-2026-09-hwp-doc/request.jpg',
          alt: '행정 업무 채팅 입력 칸에 3학년 학부모님께 보낼 현장체험학습 안내 가정통신문을 한글 파일로 만들어 달라고 적은 화면',
          caption: '"한글 파일로 만들어 줘"라고 적으면 한글 파일까지 만들어 드려요',
        },
        items: [
          '가정통신문, 기안문, 회의록, 결과 보고처럼 학교에서 자주 쓰는 문서를 만들 수 있어요.',
          '입력 칸 아래 버튼을 누르면 문서 종류별 예시 문장이 들어가요.',
        ],
      },
      {
        title: '2. 한글 파일이 오른쪽에 열려요',
        image: {
          src: '/images/help/update-2026-09-hwp-doc/editor.jpg',
          alt: '왼쪽에는 가정통신문 초안이, 오른쪽에는 제목과 표, 협조 사항이 정리된 3학년 현장체험학습 안내 한글 문서가 열린 화면',
          caption: '표와 네모 제목까지 공문 모양으로 정리돼요',
        },
        items: [
          '오른쪽 한글 편집기에서 글자를 바로 고칠 수 있어요.',
          '다 고쳤으면 오른쪽 아래 한글 파일로 저장을 누르세요.',
          '학교에서 쓰는 한글 프로그램으로 그대로 열려요.',
        ],
      },
      {
        title: '대화 속 파일 카드에서도 받을 수 있어요',
        image: {
          src: '/images/help/update-2026-09-hwp-doc/download-card.jpg',
          alt: '3학년_서울숲_생태체험_가정통신문.hwpx 파일 카드에 다운로드 버튼과 미리보기 링크가 있는 화면',
          caption: '편집기를 닫았다면 미리보기를 눌러 다시 열어요',
        },
        items: [
          '다운로드를 누르면 한글 파일을 바로 받아요.',
        ],
      },
      {
        title: '3. 평가계획서도 한글 파일로 만들어요',
        description: 'AI 평가계획서에서 성취기준을 찾아 넣고 만들기를 누르세요.',
        image: {
          src: '/images/help/update-2026-09-hwp-doc/assessment-units.jpg',
          alt: '어떤 항목으로 만들까요 창에 광합성 탐구 실험 설계, 식물 에너지 대사 분석 두 평가 항목과 전체 항목 한번에 만들기 버튼이 보이는 화면',
          caption: '평가 항목이 여러 개면 필요한 것만 고를 수 있어요',
        },
        items: [
          '필요한 항목만 골라도 되고, 전체 항목 한번에 만들기를 눌러도 돼요.',
          '빠르게는 짧게, 상세하게는 최신 교육과정을 찾아보고 더 자세하게 만들어요.',
        ],
      },
      {
        title: '학교 양식 한글 문서가 나와요',
        image: {
          src: '/images/help/update-2026-09-hwp-doc/assessment-hwp.jpg',
          alt: '새 한글 문서를 만들었어요 안내 아래 2026학년도 과학 평가계획서 한글 문서가 열리고, 작업 저장, PDF로 저장, 파일 다운로드 버튼이 보이는 화면',
          caption: '평가의 목적과 방침부터 학기 평가 계획 표까지 들어가요',
        },
        items: [
          '만드는 데 1~2분 정도 걸려요.',
          '화면에서 바로 고치고 파일 다운로드로 한글 파일을, PDF로 저장으로 PDF를 받아요.',
          '어디를 왜 바뀌었는지 보기를 누르면 AI가 무엇을 반영했는지 확인할 수 있어요.',
        ],
      },
      {
        title: '알아 두세요',
        items: [
          '가정통신문 같은 행정 문서의 한글 파일은 무료 계정에서도 만들 수 있어요.',
          '평가계획서 한글 파일과 내 한글 양식을 올려 채우는 기능은 PRO에서 쓸 수 있어요.',
          '고친 평가계획서를 다음에 다시 열려면 아래 왓퀴즈 기록에 저장도 눌러 주세요.',
        ],
      },
    ],
    links: [
      { label: '가정통신문 만들기', path: '/chat?category=admin_docs' },
      { label: '평가계획서 만들기', path: '/assessment-plan' },
    ],
  },
  {
    id: 'update-2026-01-4',
    date: '2026-01-29',
    title: '1월 4주차 업데이트',
    summary: '채팅에서 AI 모델을 골라 쓸 수 있고, 학운위 회의록 도우미가 생겼어요.',
    categories: ['chat', 'event', 'etc'],
    content: `
      <h3>AI 서비스 업그레이드</h3>
      <ul>
        <li>AI 모델 선택 기능 추가 (채팅에서 모델 자유롭게 변경 가능)</li>
        <li>무료 사용자: 빠른 모드 + 웹 검색 + 기본 추론</li>
        <li>PRO 사용자: ${PRO_MODELS_TEXT} 등 전체 모델 사용 가능</li>
        <li>전체 카테고리 Google 검색, AI 추론(Thinking) 기능 활성화</li>
      </ul>
      
      <h3>학교운영위원회 지원</h3>
      <ul>
        <li>학운위 회의록 작성 AI 도우미</li>
        <li>학운위 관련 법규/지침 안내 기능</li>
      </ul>
      
      <h3>시즌 특가 이벤트</h3>
      <ul>
        <li>PRO 첫 결제 ${_helpMaxDiscount}</li>
        <li>학교 대항전 이벤트 업데이트</li>
      </ul>
      
      <h3>기타 개선</h3>
      <ul>
        <li>채팅 UI/UX 개선 (모델 선택기 디자인 리뉴얼)</li>
        <li>카테고리별 질문 예시 개선</li>
        <li>가격 정책 페이지 업데이트</li>
      </ul>
    `,
  },
  {
    id: 'update-2026-01-3',
    date: '2026-01-20',
    title: '1월 3주차 업데이트',
    summary: '생기부 동아리·진로 탭에 자료를 올리면 AI가 분석해 써 줘요. 채팅 화면도 새로 바뀌었어요.',
    categories: ['saenggibu', 'chat', 'event', 'etc'],
    content: `
      <h3>생기부 AI - 동아리 활동 탭</h3>
      <ul>
        <li>동아리 연간 계획서 파일 첨부 및 AI 자동 분석</li>
        <li>학생 활동 자료 여러 파일 첨부 지원</li>
        <li>동아리 활동에 맞춘 전용 AI 생성</li>
      </ul>
      
      <h3>생기부 AI - 진로 활동 탭</h3>
      <ul>
        <li>진로 탐구 보고서, 활동 보고서 파일 첨부</li>
        <li>희망 학과/학교 맞춤형 AI 생성</li>
        <li>학생 정보 파일 AI 자동 분석</li>
      </ul>
      
      <h3>AI 채팅</h3>
      <ul>
        <li>채팅 UI 전면 개편 (더 깔끔하고 보기 편하게)</li>
        <li>파일 첨부 UI 간소화</li>
        <li>사용자 메시지에도 복사 버튼 추가</li>
        <li>모바일 최적화</li>
      </ul>
      
      <h3>생기부 검사기</h3>
      <ul>
        <li>AI 수정 제안 품질 향상</li>
        <li>일괄 검사 품질 단일 검사 수준으로 개선</li>
        <li>히스토리 UI 개선</li>
      </ul>
      
      <h3>이벤트</h3>
      <ul>
        <li>학교 대항전 이벤트 페이지 오픈</li>
      </ul>
      
      <h3>기타 개선</h3>
      <ul>
        <li>URL로 쿠폰 자동 등록 기능</li>
        <li>카카오톡 브라우저 호환성 개선</li>
      </ul>
    `,
  },
  {
    id: 'update-2025-12-3',
    date: '2025-12-19',
    title: '12월 3주차 업데이트 (2025 마지막)',
    summary: 'AI 오류가 나도 스스로 다시 시도하게 하고, 생기부와 이용권 기능을 다듬었어요.',
    categories: ['saenggibu', 'payment', 'event', 'etc'],
    content: `
      <h3>2025년 마지막 업데이트</h3>
      <p style="color: #6b7280; margin-bottom: 16px; line-height: 1.7;">
        올해 왓퀴즈를 이용해주신 모든 선생님께 진심으로 감사드립니다.
        저희 팀은 잠시 재충전의 시간을 갖고, 2026년 1월부터 더욱 놀라운 기능들로 찾아뵙겠습니다.
        새해에도 왓퀴즈와 함께해주세요!
      </p>
      
      <h3>서비스 안정성 강화</h3>
      <ul>
        <li>AI 응답 오류 시 자동 복구 시스템 대폭 개선</li>
        <li>일시적 오류 발생 시 사용자 친화적 안내 메시지 적용</li>
        <li>생기부 검사기 응답 안정성 향상</li>
        <li>Rate Limit 대응 시스템 고도화</li>
      </ul>
      
      <h3>생기부 AI</h3>
      <ul>
        <li>파일 사전 검사 기능 추가</li>
        <li>파일 분석 UX 개선 - 선택 유도 강화</li>
        <li>PRO 사용자 슬라이더 UX 개선</li>
        <li>프롬프트 다양성 및 품질 강화</li>
      </ul>
      
      <h3>결제/이용권</h3>
      <ul>
        <li>이용권 페이지 디자인 전면 개편</li>
        <li>환불 영수증 기능 추가</li>
        <li>'자동 결제 없음' 안내 문구 추가</li>
      </ul>
      
      <h3>이벤트</h3>
      <ul>
        <li>연말 감사 스크래치 쿠폰 이벤트 진행 중</li>
        <li>쿠폰함에서 긁어서 확인해보세요!</li>
      </ul>
      
      <h3>앞으로의 계획</h3>
      <ul>
        <li>2026년 1월: 새로운 기능 업데이트 예정</li>
        <li>더욱 편리하고 강력한 AI 도구를 준비 중입니다</li>
      </ul>
      
      <p style="color: #3b82f6; margin-top: 20px; font-weight: 500;">
        2025년 한 해 동안 감사했습니다. 따뜻한 연말 보내세요!
      </p>
    `,
  },
  {
    id: 'update-2025-12-2',
    date: '2025-12-12',
    title: '12월 2주차 업데이트',
    summary: 'PRO AI에 최신 모델이 들어오고, 생기부와 채팅이 더 좋아졌어요.',
    categories: ['chat', 'saenggibu', 'etc'],
    content: `
      <h3>PRO AI</h3>
      <ul>
        <li>${AI_MODELS.gpt.latest} 추가 - ${AI_MODELS.gpt.description} + 실시간 웹 검색</li>
        <li>${AI_MODELS.gemini.latest} - ${AI_MODELS.gemini.description}</li>
        <li>${AI_MODELS.claude.latest} - 글쓰기 특화 최고급 모델</li>
      </ul>
      
      <h3>생기부 AI</h3>
      <ul>
        <li>HWP 파일에서 표 포함 내용 추출 지원</li>
        <li>교과/세특 파일 분석 시 다중 과목/활동 선택 기능</li>
        <li>행발 파일 첨부 시 다중 학생 선택 기능</li>
        <li>일괄 생성/검사 파일 형식 확장 (xlsx, csv, hwp)</li>
        <li>영문 약어 허용 및 바이트 제한 강화</li>
      </ul>
      
      <h3>AI 채팅</h3>
      <ul>
        <li>생기부전문가 프롬프트에 영문 허용 및 독서활동 규칙 추가</li>
        <li>복사 버튼 3단계 상태 추가 (복사됨 → 완료 → 저장됨)</li>
      </ul>
      
      <h3>실험실</h3>
      <ul>
        <li>이미지 생성 기능 추가</li>
        <li>이미지 PDF 처리 지원 (스캔 문서 인식)</li>
      </ul>
      
      <h3>정책 업데이트</h3>
      <ul>
        <li>이용약관, 환불정책, 개인정보처리방침 개정 (12월 18일 시행)</li>
        <li>AI 서비스 특성 및 국외 이전 사항 명시</li>
      </ul>
      
      <h3>고객센터</h3>
      <ul>
        <li>공지사항, 업데이트, 뉴스룸 탭으로 정보 분류</li>
      </ul>
    `,
  },
  {
    id: 'update-2025-12-1',
    date: '2025-12-04',
    title: '12월 1주차 업데이트',
    summary: '교과세특에서 학교급을 고를 수 있고, 행동발달에 개별특성 탭이 생겼어요.',
    categories: ['saenggibu', 'chat', 'etc'],
    content: `
      <h3>생기부 AI</h3>
      <ul>
        <li>교과/세특 학교급 선택 기능 추가 (초등/중등/고등)</li>
        <li>행동발달에 '개별특성' 탭 추가</li>
        <li>교과(고등) 진로/희망학과 연계 기능 강화</li>
      </ul>
      
      <h3>AI 채팅</h3>
      <ul>
        <li>AI 답변 복사/공유 기능 추가</li>
        <li>대화 목록에 삭제 버튼 추가</li>
        <li>카테고리 재편 - 8개 전문가 시스템으로 정리</li>
      </ul>
      
      <h3>PRO AI</h3>
      <ul>
        <li>새로운 AI 모델 추가</li>
      </ul>
      
      <h3>성능 개선</h3>
      <ul>
        <li>서버 성능 향상</li>
        <li>AI 응답 대기 시간 증가 (복잡한 요청 처리 개선)</li>
      </ul>
    `,
  },
  {
    id: 'update-2025-11-4',
    date: '2025-11-27',
    title: '11월 4주차 업데이트',
    summary: 'SNS 공유 이벤트 페이지가 열렸어요.',
    categories: ['event'],
    content: `
      <h3>이벤트</h3>
      <ul>
        <li>SNS 공유 이벤트 페이지 추가</li>
      </ul>
    `,
  },
  {
    id: 'update-2025-11-3',
    date: '2025-11-20',
    title: '11월 3주차 업데이트',
    summary: 'PRO AI가 웹 검색과 깊은 추론을 하고, AI 서술형 채점이 좋아졌어요.',
    categories: ['chat', 'saenggibu', 'scoring', 'etc'],
    content: `
      <h3>PRO AI</h3>
      <ul>
        <li>웹 서치 및 고급 추론 기능 추가</li>
        <li>실시간 검색 과정 표시</li>
        <li>PRO AI 전용 메시지 UI 개선</li>
        <li>모든 PRO AI 모델에 웹 서치 지원</li>
      </ul>
      
      <h3>생기부 AI</h3>
      <ul>
        <li>학급 전체 생기부 일괄 생성 UI 개선</li>
        <li>검사기 AI 엔진 업그레이드</li>
        <li>명사형 어미 검사 정확도 개선</li>
      </ul>
      
      <h3>AI 서술형 채점</h3>
      <ul>
        <li>AI 서술형 채점 시스템 정식 출시</li>
      </ul>
      
      <h3>홈페이지</h3>
      <ul>
        <li>실시간 동적 통계 추가</li>
        <li>요금제 페이지 기능 비교표 UI 개선</li>
      </ul>
    `,
  },
  {
    id: 'update-2025-11-1',
    date: '2025-11-06',
    title: '11월 1주차 업데이트',
    summary: '한글(HWP·HWPX) 파일과 이미지를 올려 AI로 분석할 수 있어요.',
    categories: ['hwp', 'saenggibu'],
    content: `
      <h3>파일 지원</h3>
      <ul>
        <li>한글(HWP/HWPX) 파일 완전 지원</li>
        <li>이미지 업로드 및 AI 분석 기능</li>
        <li>파일 첨부로 AI 자동 분석 기능</li>
      </ul>
      
      <h3>생기부 AI</h3>
      <ul>
        <li>교과/세특(고등) 카테고리 추가</li>
        <li>성취수준별 학생 수 독립 설정 기능</li>
        <li>생기부 검사기 히스토리 시스템 추가</li>
        <li>엑셀 일괄 생성 UI 대폭 간소화</li>
        <li>커스텀 예시 기능 추가</li>
      </ul>
      
      <h3>생성 품질</h3>
      <ul>
        <li>AI 모델 최적화</li>
        <li>중복 표현 제거 및 어휘 다양성 강화</li>
        <li>바이트 수 달성률 개선</li>
      </ul>
      
      <h3>검사기</h3>
      <ul>
        <li>검사기 UI/UX 대폭 개선</li>
        <li>AI 수정문 생성 품질 향상</li>
        <li>문맥 이해 우선 프로세스 추가</li>
      </ul>
    `,
  },
  {
    id: 'update-2025-10',
    date: '2025-10-15',
    title: '10월 업데이트',
    summary: '생기부 검사기가 띄어쓰기·맞춤법까지 더 꼼꼼하게 봐요.',
    categories: ['saenggibu'],
    content: `
      <h3>생기부 검사기</h3>
      <ul>
        <li>검사 예시에 띄어쓰기/맞춤법 오류 추가</li>
        <li>연결어미 허용 및 수정 제안 품질 개선</li>
        <li>워딩 순화 및 점수 제거</li>
      </ul>
      
      <h3>생기부 AI</h3>
      <ul>
        <li>교과/세특 카테고리 전용 프롬프트 구현</li>
        <li>행발 예시 카테고리별 구분 UI</li>
        <li>학생 수 설정 방식 개선 (5-30명)</li>
        <li>생기부 기록 엑셀 일괄 다운로드 기능</li>
      </ul>
      
      <h3>생성 품질</h3>
      <ul>
        <li>후반부 과도 압축 문제 해결</li>
        <li>바이트 부족 문제 개선</li>
        <li>파라미터 3단계 최적화</li>
      </ul>
    `,
  },
  {
    id: 'update-2025-09',
    date: '2025-09-15',
    title: '9월 업데이트',
    summary: '엑셀로 생기부를 한꺼번에 만들고, 쿠폰과 공지 기능이 생겼어요.',
    categories: ['saenggibu', 'payment', 'etc'],
    content: `
      <h3>생기부 AI</h3>
      <ul>
        <li>엑셀 일괄 생기부 생성 독립 페이지</li>
        <li>생기부 파일 첨부 기능 추가 (PRO 전용)</li>
        <li>AI 기반 학생 정보 분석 및 선택 인터페이스</li>
        <li>파일 업로드 UI 전면 개선</li>
      </ul>
      
      <h3>쿠폰 시스템</h3>
      <ul>
        <li>쿠폰 등록 기능 추가</li>
      </ul>
      
      <h3>공지 시스템</h3>
      <ul>
        <li>범용 공지 모달 시스템 구축</li>
      </ul>
    `,
  },
  {
    id: 'update-2025-08',
    date: '2025-08-15',
    title: '8월 업데이트',
    summary: '생기부 기록을 다시 보고, 여러 버전을 한 번에 만들 수 있어요.',
    categories: ['saenggibu', 'event'],
    content: `
      <h3>생기부 AI</h3>
      <ul>
        <li>생기부 기록 히스토리 기능</li>
        <li>다중 버전 생성 기능 (한 번에 여러 버전)</li>
        <li>PRO 전용 고급 옵션 추가</li>
      </ul>
      
      <h3>이벤트</h3>
      <ul>
        <li>교사 프로필 이벤트 페이지 오픈</li>
      </ul>
    `,
  },
  {
    id: 'update-2025-07',
    date: '2025-07-15',
    title: '7월 업데이트',
    summary: '채팅에 파일을 끌어다 올리고, PRO 모델을 골라 쓸 수 있어요.',
    categories: ['chat', 'payment', 'etc'],
    content: `
      <h3>AI 채팅</h3>
      <ul>
        <li>파일 첨부 기능 추가 (드래그앤드롭 지원)</li>
        <li>PRO AI 모델 선택 기능</li>
        <li>대화별 마지막 전문가 기억 기능</li>
        <li>월별 핵심 업무 섹션 추가</li>
      </ul>
      
      <h3>요금제</h3>
      <ul>
        <li>기간제 요금제 시스템 개편</li>
        <li>환불 정책 개선 (전자상거래법 준수)</li>
        <li>단체 구매 문의 시스템</li>
      </ul>
      
      <h3>학급 관리</h3>
      <ul>
        <li>학급 목록 및 관리 기능 추가</li>
        <li>학생 번호 기반 생기부 키 매칭</li>
      </ul>
    `,
  },
  {
    id: 'update-2025-06',
    date: '2025-06-15',
    title: '6월 업데이트',
    summary: '선생님끼리 이야기하는 익명 커뮤니티가 열렸어요.',
    categories: ['etc', 'chat', 'event'],
    content: `
      <h3>교사 커뮤니티</h3>
      <ul>
        <li>교사 전용 익명 커뮤니티 오픈</li>
        <li>글 조회수 및 댓글 시스템</li>
        <li>비밀글 작성 기능</li>
      </ul>
      
      <h3>AI 채팅</h3>
      <ul>
        <li>전문가 카테고리 시스템 개편</li>
        <li>카테고리별 맞춤 예시 질문 제공</li>
        <li>공문서 작성 전문가 추가</li>
      </ul>
      
      <h3>이벤트</h3>
      <ul>
        <li>이벤트 페이지 오픈</li>
        <li>이벤트 팝업 시스템 추가</li>
        <li>앰버서더/블로그 포스팅 이벤트</li>
      </ul>
      
      <h3>PRO AI</h3>
      <ul>
        <li>새로운 AI 모델 추가</li>
        <li>모델별 설명 및 특성 안내</li>
      </ul>
      
      <h3>홈페이지</h3>
      <ul>
        <li>랜딩페이지 디자인 전면 리뉴얼</li>
        <li>PRO/기관용 서비스 안내 섹션 추가</li>
      </ul>
    `,
  },
  {
    id: 'update-2025-05',
    date: '2025-05-15',
    title: '5월 업데이트',
    summary: '동시 접속을 더 잘 버티게 하고, 수식과 모바일 화면을 다듬었어요.',
    categories: ['etc'],
    content: `
      <h3>성능 개선</h3>
      <ul>
        <li>동시 접속자 처리 성능 대폭 향상</li>
        <li>서버 안정성 강화</li>
      </ul>
      
      <h3>고객센터</h3>
      <ul>
        <li>도움말 센터 전면 구축</li>
        <li>분야별 FAQ 페이지 추가</li>
        <li>결제/기술지원/학습지 도움말</li>
      </ul>
      
      <h3>수식 지원</h3>
      <ul>
        <li>수학 수식 렌더링 지원 (LaTeX)</li>
        <li>자유형 학습지/수행평가 수식 표시</li>
      </ul>
      
      <h3>모바일 최적화</h3>
      <ul>
        <li>표(테이블) 좌우 스크롤 지원</li>
        <li>반응형 레이아웃 개선</li>
      </ul>
      
      <h3>Pro 사용자</h3>
      <ul>
        <li>PRO 혜택 명확화</li>
        <li>토큰 시스템 안정화</li>
      </ul>
    `,
  },
  {
    id: 'update-2025-04',
    date: '2025-04-15',
    title: '4월 업데이트',
    summary: '학생이 직접 푸는 퀴즈 페이지와 QR 공유가 생겼어요.',
    categories: ['quiz', 'chat', 'etc'],
    content: `
      <h3>학생 퀴즈</h3>
      <ul>
        <li>학생용 퀴즈 풀이 페이지 추가</li>
        <li>QR 코드 공유 기능</li>
        <li>학생 닉네임 입력 시스템</li>
        <li>퀴즈 결과 리뷰 토글 형식 변경</li>
      </ul>
      
      <h3>PDF 기능</h3>
      <ul>
        <li>학생용 PDF 시험지 형태 지원</li>
        <li>문제별 페이지 나누기 기능</li>
        <li>PDF 한글 깨짐 문제 해결</li>
        <li>정답 위치 랜덤화</li>
      </ul>
      
      <h3>링크 공유</h3>
      <ul>
        <li>공유 시 미리보기 이미지 최적화</li>
        <li>SNS 공유 기능 개선</li>
      </ul>
      
      <h3>AI 채팅</h3>
      <ul>
        <li>딥서치 기능 교육 최적화</li>
        <li>응답 생성 중 메시지 순환 표시</li>
        <li>교사용 예시 질문 추가</li>
      </ul>
      
      <h3>UI/UX</h3>
      <ul>
        <li>메시지 복사 기능 추가</li>
        <li>피드백 팝업 개선</li>
        <li>해설보기 버튼 및 스크롤 기능</li>
        <li>로딩 스피너 개선</li>
      </ul>
    `,
  },
];
